//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IConcentrationUomClient {
    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    get(enabledOnly: boolean | undefined): Observable<ConcentrationUomModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    put(body: ConcentrationUomModel | undefined): Observable<ConcentrationUomModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: ConcentrationUomModel | undefined): Observable<ConcentrationUomModel>;
    /**
     * @param uomDisplay (optional) 
     * @return Success
     */
    checkDuplicate(uomDisplay: string | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ConcentrationUomClient implements IConcentrationUomClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    get(enabledOnly: boolean | undefined): Observable<ConcentrationUomModel[]> {
        let url_ = this.baseUrl + "/api/ConcentrationUom?";
        if (enabledOnly === null)
            throw new Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConcentrationUomModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConcentrationUomModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ConcentrationUomModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConcentrationUomModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConcentrationUomModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    put(body: ConcentrationUomModel | undefined): Observable<ConcentrationUomModel> {
        let url_ = this.baseUrl + "/api/ConcentrationUom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConcentrationUomModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConcentrationUomModel>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ConcentrationUomModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConcentrationUomModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConcentrationUomModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: ConcentrationUomModel | undefined): Observable<ConcentrationUomModel> {
        let url_ = this.baseUrl + "/api/ConcentrationUom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConcentrationUomModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConcentrationUomModel>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ConcentrationUomModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConcentrationUomModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConcentrationUomModel>(null as any);
    }

    /**
     * @param uomDisplay (optional) 
     * @return Success
     */
    checkDuplicate(uomDisplay: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ConcentrationUom/CheckDuplicate?";
        if (uomDisplay === null)
            throw new Error("The parameter 'uomDisplay' cannot be null.");
        else if (uomDisplay !== undefined)
            url_ += "UomDisplay=" + encodeURIComponent("" + uomDisplay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IConnectionsClient {
    /**
     * @return Success
     */
    getConnectionTypes(): Observable<void>;
    /**
     * @param connectionType (optional) 
     * @param connectionString (optional) 
     * @return Success
     */
    getConnectionTables(connectionType: string | undefined, connectionString: string | undefined): Observable<void>;
    /**
     * @param connectionType (optional) 
     * @return Success
     */
    makeConnectionString(connectionType: string | undefined): Observable<void>;
    /**
     * @param connectionType (optional) 
     * @param connectionString (optional) 
     * @return Success
     */
    getConnectionStringProperties(connectionType: string | undefined, connectionString: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ConnectionsClient implements IConnectionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getConnectionTypes(): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getConnectionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetConnectionTypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param connectionType (optional) 
     * @param connectionString (optional) 
     * @return Success
     */
    getConnectionTables(connectionType: string | undefined, connectionString: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getConnectionTables?";
        if (connectionType === null)
            throw new Error("The parameter 'connectionType' cannot be null.");
        else if (connectionType !== undefined)
            url_ += "ConnectionType=" + encodeURIComponent("" + connectionType) + "&";
        if (connectionString === null)
            throw new Error("The parameter 'connectionString' cannot be null.");
        else if (connectionString !== undefined)
            url_ += "ConnectionString=" + encodeURIComponent("" + connectionString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetConnectionTables(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param connectionType (optional) 
     * @return Success
     */
    makeConnectionString(connectionType: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.makeConnectionString?";
        if (connectionType === null)
            throw new Error("The parameter 'connectionType' cannot be null.");
        else if (connectionType !== undefined)
            url_ += "connectionType=" + encodeURIComponent("" + connectionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeConnectionString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeConnectionString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMakeConnectionString(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param connectionType (optional) 
     * @param connectionString (optional) 
     * @return Success
     */
    getConnectionStringProperties(connectionType: string | undefined, connectionString: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getConnectionStringProperties?";
        if (connectionType === null)
            throw new Error("The parameter 'connectionType' cannot be null.");
        else if (connectionType !== undefined)
            url_ += "ConnectionType=" + encodeURIComponent("" + connectionType) + "&";
        if (connectionString === null)
            throw new Error("The parameter 'connectionString' cannot be null.");
        else if (connectionString !== undefined)
            url_ += "ConnectionString=" + encodeURIComponent("" + connectionString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionStringProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionStringProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetConnectionStringProperties(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ICountryClient {
    /**
     * @return Success
     */
    getCountries(): Observable<CountryModel[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postCountry(body: CountryModel | undefined): Observable<CountryModel>;
    /**
     * @return Success
     */
    getReportGET(): Observable<void>;
    /**
     * @return Success
     */
    getReportByRegion(): Observable<void>;
    /**
     * @return Success
     */
    getCountry(id: number): Observable<CountryModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    putCountry(id: number, body: CountryModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    deleteCountry(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CountryClient implements ICountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCountries(): Observable<CountryModel[]> {
        let url_ = this.baseUrl + "/api/Country";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryModel[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CountryModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postCountry(body: CountryModel | undefined): Observable<CountryModel> {
        let url_ = this.baseUrl + "/api/Country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryModel>;
        }));
    }

    protected processPostCountry(response: HttpResponseBase): Observable<CountryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = CountryModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryModel>(null as any);
    }

    /**
     * @return Success
     */
    getReportGET(): Observable<void> {
        let url_ = this.baseUrl + "/api/Country/report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReportGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getReportByRegion(): Observable<void> {
        let url_ = this.baseUrl + "/api/Country/reportByRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportByRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReportByRegion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getCountry(id: number): Observable<CountryModel> {
        let url_ = this.baseUrl + "/api/Country/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryModel>;
        }));
    }

    protected processGetCountry(response: HttpResponseBase): Observable<CountryModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = CountryModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    putCountry(id: number, body: CountryModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Country/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCountry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteCountry(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Country/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCountry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IDelegatesClient {
    /**
     * @return Success
     */
    getDelegations(userId: number): Observable<LeaderDelegatesModel[]>;
    /**
     * @param leaderId (optional) 
     * @param delegateId (optional) 
     * @return Success
     */
    addDelegate(leaderId: number | undefined, delegateId: number | undefined): Observable<void>;
    /**
     * @param leaderId (optional) 
     * @param delegateId (optional) 
     * @return Success
     */
    deleteDelegate(leaderId: number | undefined, delegateId: number | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class DelegatesClient implements IDelegatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getDelegations(userId: number): Observable<LeaderDelegatesModel[]> {
        let url_ = this.baseUrl + "/api/Delegates/GetDelegations/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaderDelegatesModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaderDelegatesModel[]>;
        }));
    }

    protected processGetDelegations(response: HttpResponseBase): Observable<LeaderDelegatesModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LeaderDelegatesModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaderDelegatesModel[]>(null as any);
    }

    /**
     * @param leaderId (optional) 
     * @param delegateId (optional) 
     * @return Success
     */
    addDelegate(leaderId: number | undefined, delegateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Delegates/AddDelegation?";
        if (leaderId === null)
            throw new Error("The parameter 'leaderId' cannot be null.");
        else if (leaderId !== undefined)
            url_ += "leaderId=" + encodeURIComponent("" + leaderId) + "&";
        if (delegateId === null)
            throw new Error("The parameter 'delegateId' cannot be null.");
        else if (delegateId !== undefined)
            url_ += "delegateId=" + encodeURIComponent("" + delegateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDelegate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDelegate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDelegate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param leaderId (optional) 
     * @param delegateId (optional) 
     * @return Success
     */
    deleteDelegate(leaderId: number | undefined, delegateId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Delegates/RemoveDelegation?";
        if (leaderId === null)
            throw new Error("The parameter 'leaderId' cannot be null.");
        else if (leaderId !== undefined)
            url_ += "leaderId=" + encodeURIComponent("" + leaderId) + "&";
        if (delegateId === null)
            throw new Error("The parameter 'delegateId' cannot be null.");
        else if (delegateId !== undefined)
            url_ += "delegateId=" + encodeURIComponent("" + delegateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDelegate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDelegate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDelegate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IDesignerReportClient {
    /**
     * @param reportId (optional) 
     * @return Success
     */
    getReportGET2(reportId: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @return Success
     */
    saveReport(reportId: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @return Success
     */
    getPreviewReport(reportId: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class DesignerReportClient implements IDesignerReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getReportGET2(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReportGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    saveReport(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.saveReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getPreviewReport(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.previewReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviewReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviewReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetPreviewReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IExportReportClient {
    /**
     * @param reportId (optional) 
     * @param exportFormat (optional) 
     * @return Success
     */
    exportReport(reportId: string | undefined, exportFormat: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @param format (optional) 
     * @return Success
     */
    getExportSettings(reportId: string | undefined, format: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportReportClient implements IExportReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportId (optional) 
     * @param exportFormat (optional) 
     * @return Success
     */
    exportReport(reportId: string | undefined, exportFormat: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/preview.exportReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (exportFormat === null)
            throw new Error("The parameter 'exportFormat' cannot be null.");
        else if (exportFormat !== undefined)
            url_ += "ExportFormat=" + encodeURIComponent("" + exportFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param format (optional) 
     * @return Success
     */
    getExportSettings(reportId: string | undefined, format: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/exportsettings.getSettings?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "Format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetExportSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IForecastingSeasonClient {
    /**
     * @return Success
     */
    getForecastingSeasons(): Observable<ForecastingSeasonModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createForecastingSeason(body: ForecastingSeasonModel | undefined): Observable<ForecastingSeasonModel>;
    /**
     * @return Success
     */
    getForecastingSeason(id: number): Observable<ForecastingSeasonModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateForecastingSeason(id: number, body: ForecastingSeasonModel | undefined): Observable<void>;
    /**
     * @return No Content
     */
    deleteForecastingSeason(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastingSeasonClient implements IForecastingSeasonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getForecastingSeasons(): Observable<ForecastingSeasonModel[]> {
        let url_ = this.baseUrl + "/api/ForecastingSeason";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastingSeasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastingSeasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastingSeasonModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastingSeasonModel[]>;
        }));
    }

    protected processGetForecastingSeasons(response: HttpResponseBase): Observable<ForecastingSeasonModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastingSeasonModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastingSeasonModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createForecastingSeason(body: ForecastingSeasonModel | undefined): Observable<ForecastingSeasonModel> {
        let url_ = this.baseUrl + "/api/ForecastingSeason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForecastingSeason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForecastingSeason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastingSeasonModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastingSeasonModel>;
        }));
    }

    protected processCreateForecastingSeason(response: HttpResponseBase): Observable<ForecastingSeasonModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastingSeasonModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = ForecastingSeasonModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastingSeasonModel>(null as any);
    }

    /**
     * @return Success
     */
    getForecastingSeason(id: number): Observable<ForecastingSeasonModel> {
        let url_ = this.baseUrl + "/api/ForecastingSeason/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastingSeason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastingSeason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastingSeasonModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastingSeasonModel>;
        }));
    }

    protected processGetForecastingSeason(response: HttpResponseBase): Observable<ForecastingSeasonModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastingSeasonModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastingSeasonModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateForecastingSeason(id: number, body: ForecastingSeasonModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastingSeason/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForecastingSeason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForecastingSeason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateForecastingSeason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteForecastingSeason(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastingSeason/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForecastingSeason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForecastingSeason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteForecastingSeason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IForecastItemClient {
    /**
     * @return Success
     */
    getForecastItems(userId: number): Observable<ForecastItemModel[]>;
    /**
     * @return Success
     */
    getPaginatedForecastItems(pageIndex: number, pageSize: number, userId: number): Observable<ForecastItemDTO>;
    /**
     * @param body (optional) 
     * @return Success
     */
    filterForecatItems(userId: number, pageIndex: number, pageSize: number, body: CustomFilterModel | undefined): Observable<ForecastItemDTO>;
    /**
     * @return Success
     */
    getDashboardData(userId: number): Observable<DashboardModel[]>;
    /**
     * @return Success
     */
    getForecastItem(id: number): Observable<ForecastItemModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateForecastItem(id: number, body: ForecastItemModel | undefined): Observable<void>;
    /**
     * @return No Content
     */
    deleteForecastItem(id: number): Observable<void>;
    /**
     * @return Success
     */
    getForecastItemByMaterial(repoName: string, materialId: string): Observable<ForecastItemModel>;
    /**
     * @return Success
     */
    productSearch(id: number): Observable<ProductResult>;
    /**
     * @return Success
     */
    getForecastItemsAwaitingApproval(userId: number, pageIndex: number, pageSize: number): Observable<ForecastMaterialApprovalModelResult>;
    /**
     * @return Success
     */
    getForecastItemComments(forecastId: number): Observable<ForecastItemCommentLogModelResult>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createForecastItem(body: ForecastItemModel | undefined): Observable<ForecastItemModel>;
    /**
     * @param body (optional) 
     * @return Created
     */
    updateComments(source: string, body: ForecastItemModel | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    forecastApproval(body: ApproveForecastModel | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createDelegateForecastItem(body: ForecastItemDelegatedUsers | undefined): Observable<ForecastItemModel>;
    /**
     * @param input (optional) 
     * @param isForecastSeason (optional) 
     * @param isLeadership (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getReportGET3(input: number | undefined, isForecastSeason: boolean | undefined, isLeadership: boolean | undefined, userId: number | undefined): Observable<void>;
    /**
     * @return Success
     */
    getOrderSummaryReport(year: number, userId: number): Observable<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateForecastItemStatus(body: ApproveForecastModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    getAllForecaster(input: string): Observable<UserModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastItemClient implements IForecastItemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getForecastItems(userId: number): Observable<ForecastItemModel[]> {
        let url_ = this.baseUrl + "/api/ForecastItem/GetForecastItems/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemModel[]>;
        }));
    }

    protected processGetForecastItems(response: HttpResponseBase): Observable<ForecastItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastItemModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPaginatedForecastItems(pageIndex: number, pageSize: number, userId: number): Observable<ForecastItemDTO> {
        let url_ = this.baseUrl + "/api/ForecastItem/GetPaginatedForecastItems/{pageIndex}/{pageSize}/{userId}";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined.");
        url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginatedForecastItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginatedForecastItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemDTO>;
        }));
    }

    protected processGetPaginatedForecastItems(response: HttpResponseBase): Observable<ForecastItemDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemDTO.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterForecatItems(userId: number, pageIndex: number, pageSize: number, body: CustomFilterModel | undefined): Observable<ForecastItemDTO> {
        let url_ = this.baseUrl + "/api/ForecastItem/FilterMyForecast/{userId}/{pageIndex}/{pageSize}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined.");
        url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterForecatItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterForecatItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemDTO>;
        }));
    }

    protected processFilterForecatItems(response: HttpResponseBase): Observable<ForecastItemDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemDTO.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemDTO>(null as any);
    }

    /**
     * @return Success
     */
    getDashboardData(userId: number): Observable<DashboardModel[]> {
        let url_ = this.baseUrl + "/api/ForecastItem/GetDashboardData/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardModel[]>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<DashboardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DashboardModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getForecastItem(id: number): Observable<ForecastItemModel> {
        let url_ = this.baseUrl + "/api/ForecastItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemModel>;
        }));
    }

    protected processGetForecastItem(response: HttpResponseBase): Observable<ForecastItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateForecastItem(id: number, body: ForecastItemModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForecastItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForecastItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateForecastItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteForecastItem(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForecastItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForecastItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteForecastItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getForecastItemByMaterial(repoName: string, materialId: string): Observable<ForecastItemModel> {
        let url_ = this.baseUrl + "/api/ForecastItem/{repoName}/{materialId}";
        if (repoName === undefined || repoName === null)
            throw new Error("The parameter 'repoName' must be defined.");
        url_ = url_.replace("{repoName}", encodeURIComponent("" + repoName));
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastItemByMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastItemByMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemModel>;
        }));
    }

    protected processGetForecastItemByMaterial(response: HttpResponseBase): Observable<ForecastItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemModel>(null as any);
    }

    /**
     * @return Success
     */
    productSearch(id: number): Observable<ProductResult> {
        let url_ = this.baseUrl + "/api/ForecastItem/ProductSearch/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductResult>;
        }));
    }

    protected processProductSearch(response: HttpResponseBase): Observable<ProductResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProductResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductResult>(null as any);
    }

    /**
     * @return Success
     */
    getForecastItemsAwaitingApproval(userId: number, pageIndex: number, pageSize: number): Observable<ForecastMaterialApprovalModelResult> {
        let url_ = this.baseUrl + "/api/ForecastItem/MaterialApproval/{userId}/{pageIndex}/{pageSize}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined.");
        url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastItemsAwaitingApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastItemsAwaitingApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastMaterialApprovalModelResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastMaterialApprovalModelResult>;
        }));
    }

    protected processGetForecastItemsAwaitingApproval(response: HttpResponseBase): Observable<ForecastMaterialApprovalModelResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastMaterialApprovalModelResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastMaterialApprovalModelResult>(null as any);
    }

    /**
     * @return Success
     */
    getForecastItemComments(forecastId: number): Observable<ForecastItemCommentLogModelResult> {
        let url_ = this.baseUrl + "/api/ForecastItem/Comments/{forecastId}";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastItemComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastItemComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemCommentLogModelResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemCommentLogModelResult>;
        }));
    }

    protected processGetForecastItemComments(response: HttpResponseBase): Observable<ForecastItemCommentLogModelResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemCommentLogModelResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemCommentLogModelResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createForecastItem(body: ForecastItemModel | undefined): Observable<ForecastItemModel> {
        let url_ = this.baseUrl + "/api/ForecastItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForecastItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForecastItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemModel>;
        }));
    }

    protected processCreateForecastItem(response: HttpResponseBase): Observable<ForecastItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = ForecastItemModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateComments(source: string, body: ForecastItemModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/UpdateComments/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateComments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    forecastApproval(body: ApproveForecastModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/Approval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForecastApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForecastApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForecastApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createDelegateForecastItem(body: ForecastItemDelegatedUsers | undefined): Observable<ForecastItemModel> {
        let url_ = this.baseUrl + "/api/ForecastItem/CloneDelegate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDelegateForecastItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDelegateForecastItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemModel>;
        }));
    }

    protected processCreateDelegateForecastItem(response: HttpResponseBase): Observable<ForecastItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = ForecastItemModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemModel>(null as any);
    }

    /**
     * @param input (optional) 
     * @param isForecastSeason (optional) 
     * @param isLeadership (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getReportGET3(input: number | undefined, isForecastSeason: boolean | undefined, isLeadership: boolean | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/GetForecastSummaryReport?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (isForecastSeason === null)
            throw new Error("The parameter 'isForecastSeason' cannot be null.");
        else if (isForecastSeason !== undefined)
            url_ += "isForecastSeason=" + encodeURIComponent("" + isForecastSeason) + "&";
        if (isLeadership === null)
            throw new Error("The parameter 'isLeadership' cannot be null.");
        else if (isLeadership !== undefined)
            url_ += "isLeadership=" + encodeURIComponent("" + isLeadership) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReportGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getOrderSummaryReport(year: number, userId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/GetOrderSummaryReport/{year}/{userId}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderSummaryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderSummaryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetOrderSummaryReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateForecastItemStatus(body: ApproveForecastModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItem/Status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForecastItemStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForecastItemStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateForecastItemStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllForecaster(input: string): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/ForecastItem/GetAllForecaster/{input}";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined.");
        url_ = url_.replace("{input}", encodeURIComponent("" + input));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForecaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForecaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetAllForecaster(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }
}

export interface IForecastItemActiveIngredientClient {
    /**
     * @return Success
     */
    getActiveIngredients(): Observable<ForecastItemActiveIngredientModel[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createActiveIngredient(body: ForecastItemActiveIngredientModel | undefined): Observable<ForecastItemActiveIngredientModel>;
    /**
     * @return Success
     */
    getActiveIngredient(id: number): Observable<ForecastItemActiveIngredientModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateActiveIngredient(id: number, body: ForecastItemActiveIngredientModel | undefined): Observable<void>;
    /**
     * @return No Content
     */
    deleteActiveIngredient(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastItemActiveIngredientClient implements IForecastItemActiveIngredientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getActiveIngredients(): Observable<ForecastItemActiveIngredientModel[]> {
        let url_ = this.baseUrl + "/api/ForecastItemActiveIngredient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveIngredients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveIngredients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemActiveIngredientModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemActiveIngredientModel[]>;
        }));
    }

    protected processGetActiveIngredients(response: HttpResponseBase): Observable<ForecastItemActiveIngredientModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastItemActiveIngredientModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemActiveIngredientModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createActiveIngredient(body: ForecastItemActiveIngredientModel | undefined): Observable<ForecastItemActiveIngredientModel> {
        let url_ = this.baseUrl + "/api/ForecastItemActiveIngredient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActiveIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActiveIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemActiveIngredientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemActiveIngredientModel>;
        }));
    }

    protected processCreateActiveIngredient(response: HttpResponseBase): Observable<ForecastItemActiveIngredientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = ForecastItemActiveIngredientModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemActiveIngredientModel>(null as any);
    }

    /**
     * @return Success
     */
    getActiveIngredient(id: number): Observable<ForecastItemActiveIngredientModel> {
        let url_ = this.baseUrl + "/api/ForecastItemActiveIngredient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemActiveIngredientModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemActiveIngredientModel>;
        }));
    }

    protected processGetActiveIngredient(response: HttpResponseBase): Observable<ForecastItemActiveIngredientModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemActiveIngredientModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemActiveIngredientModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateActiveIngredient(id: number, body: ForecastItemActiveIngredientModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItemActiveIngredient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActiveIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActiveIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActiveIngredient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteActiveIngredient(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItemActiveIngredient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActiveIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActiveIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteActiveIngredient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IForecastItemDestinationClient {
    /**
     * @return Success
     */
    getDestinations(forecastId: number): Observable<ForecastItemDestinationModel[]>;
    /**
     * @return Success
     */
    getDestination(id: number): Observable<ForecastItemDestinationModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDestination(id: number, body: ForecastItemDestinationModel | undefined): Observable<void>;
    /**
     * @return No Content
     */
    deleteDestination(id: number): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createDestination(body: ForecastItemDestinationModel | undefined): Observable<ForecastItemDestinationModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDestinationMin(id: number, body: ForecastItemDestinationModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    getUsedQuantity(forecastDestId: number): Observable<number>;
    /**
     * @return Success
     */
    getOrderedQuantity(forecastDestId: number): Observable<number>;
    /**
     * @return Success
     */
    getAdvancedQuantity(forecastDestId: number): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastItemDestinationClient implements IForecastItemDestinationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getDestinations(forecastId: number): Observable<ForecastItemDestinationModel[]> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/GetDestinations/{forecastId}";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemDestinationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemDestinationModel[]>;
        }));
    }

    protected processGetDestinations(response: HttpResponseBase): Observable<ForecastItemDestinationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastItemDestinationModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemDestinationModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getDestination(id: number): Observable<ForecastItemDestinationModel> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemDestinationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemDestinationModel>;
        }));
    }

    protected processGetDestination(response: HttpResponseBase): Observable<ForecastItemDestinationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemDestinationModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemDestinationModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDestination(id: number, body: ForecastItemDestinationModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDestination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteDestination(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDestination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createDestination(body: ForecastItemDestinationModel | undefined): Observable<ForecastItemDestinationModel> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemDestinationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemDestinationModel>;
        }));
    }

    protected processCreateDestination(response: HttpResponseBase): Observable<ForecastItemDestinationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = ForecastItemDestinationModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemDestinationModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDestinationMin(id: number, body: ForecastItemDestinationModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/UpdateDestinationMin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDestinationMin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDestinationMin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDestinationMin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getUsedQuantity(forecastDestId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/GetUsedQuantity/{forecastDestId}";
        if (forecastDestId === undefined || forecastDestId === null)
            throw new Error("The parameter 'forecastDestId' must be defined.");
        url_ = url_.replace("{forecastDestId}", encodeURIComponent("" + forecastDestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUsedQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getOrderedQuantity(forecastDestId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/GetOrderedQuantity/{forecastDestId}";
        if (forecastDestId === undefined || forecastDestId === null)
            throw new Error("The parameter 'forecastDestId' must be defined.");
        url_ = url_.replace("{forecastDestId}", encodeURIComponent("" + forecastDestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOrderedQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getAdvancedQuantity(forecastDestId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/ForecastItemDestination/GetAdvancedQuantity/{forecastDestId}";
        if (forecastDestId === undefined || forecastDestId === null)
            throw new Error("The parameter 'forecastDestId' must be defined.");
        url_ = url_.replace("{forecastDestId}", encodeURIComponent("" + forecastDestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvancedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvancedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAdvancedQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

export interface IForecastStateClient {
    /**
     * @return Success
     */
    getForecastStates(): Observable<ForecastStateModel[]>;
    /**
     * @return Success
     */
    getForecastState(id: number): Observable<ForecastStateModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastStateClient implements IForecastStateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getForecastStates(): Observable<ForecastStateModel[]> {
        let url_ = this.baseUrl + "/api/ForecastState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastStateModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastStateModel[]>;
        }));
    }

    protected processGetForecastStates(response: HttpResponseBase): Observable<ForecastStateModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastStateModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastStateModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getForecastState(id: number): Observable<ForecastStateModel> {
        let url_ = this.baseUrl + "/api/ForecastState/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastStateModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastStateModel>;
        }));
    }

    protected processGetForecastState(response: HttpResponseBase): Observable<ForecastStateModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastStateModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastStateModel>(null as any);
    }
}

export interface IForecastTypeClient {
    /**
     * @return Success
     */
    getForecastTypes(): Observable<ForecastTypeModel[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createForecastType(body: ForecastTypeModel | undefined): Observable<ForecastTypeModel>;
    /**
     * @return Success
     */
    getForecastType(id: number): Observable<ForecastTypeModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastTypeClient implements IForecastTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getForecastTypes(): Observable<ForecastTypeModel[]> {
        let url_ = this.baseUrl + "/api/ForecastType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastTypeModel[]>;
        }));
    }

    protected processGetForecastTypes(response: HttpResponseBase): Observable<ForecastTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastTypeModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastTypeModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createForecastType(body: ForecastTypeModel | undefined): Observable<ForecastTypeModel> {
        let url_ = this.baseUrl + "/api/ForecastType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForecastType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForecastType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastTypeModel>;
        }));
    }

    protected processCreateForecastType(response: HttpResponseBase): Observable<ForecastTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = ForecastTypeModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastTypeModel>(null as any);
    }

    /**
     * @return Success
     */
    getForecastType(id: number): Observable<ForecastTypeModel> {
        let url_ = this.baseUrl + "/api/ForecastType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastTypeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastTypeModel>;
        }));
    }

    protected processGetForecastType(response: HttpResponseBase): Observable<ForecastTypeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastTypeModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastTypeModel>(null as any);
    }
}

export interface IFormulationTypesClient {
    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    get2(enabledOnly: boolean | undefined): Observable<FormulationTypeServiceModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    put2(body: FormulationTypeServiceModel | undefined): Observable<FormulationTypeServiceModel>;
}

@Injectable({
    providedIn: 'root'
})
export class FormulationTypesClient implements IFormulationTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    get2(enabledOnly: boolean | undefined): Observable<FormulationTypeServiceModel[]> {
        let url_ = this.baseUrl + "/api/FormulationTypes?";
        if (enabledOnly === null)
            throw new Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormulationTypeServiceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormulationTypeServiceModel[]>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FormulationTypeServiceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FormulationTypeServiceModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormulationTypeServiceModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    put2(body: FormulationTypeServiceModel | undefined): Observable<FormulationTypeServiceModel> {
        let url_ = this.baseUrl + "/api/FormulationTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormulationTypeServiceModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormulationTypeServiceModel>;
        }));
    }

    protected processPut2(response: HttpResponseBase): Observable<FormulationTypeServiceModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = FormulationTypeServiceModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormulationTypeServiceModel>(null as any);
    }
}

export interface IGetPictureClient {
    /**
     * @param reportId (optional) 
     * @param pictureId (optional) 
     * @return Success
     */
    getPicture(reportId: string | undefined, pictureId: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class GetPictureClient implements IGetPictureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportId (optional) 
     * @param pictureId (optional) 
     * @return Success
     */
    getPicture(reportId: string | undefined, pictureId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/preview.getPicture?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (pictureId === null)
            throw new Error("The parameter 'pictureId' cannot be null.");
        else if (pictureId !== undefined)
            url_ += "PictureId=" + encodeURIComponent("" + pictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetPicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IGetReportClient {
    /**
     * @param reportId (optional) 
     * @param clickParams_Click (optional) 
     * @param clickParams_CheckBoxClick (optional) 
     * @param clickParams_TextEdit (optional) 
     * @param clickParams_Text (optional) 
     * @param clickParams_AdvMatrixClick (optional) 
     * @param dialogParams_DialogN (optional) 
     * @param dialogParams_DialogControlName (optional) 
     * @param dialogParams_DialogEventName (optional) 
     * @param dialogParams_DialogData (optional) 
     * @param reportTabParams_SetTab (optional) 
     * @param reportTabParams_CloseTab (optional) 
     * @param reportPageParams_GoTo (optional) 
     * @param reportPageParams_Bookmark (optional) 
     * @param reportPageParams_DetailedReport (optional) 
     * @param reportPageParams_DetailedPage (optional) 
     * @param renderBody (optional) 
     * @param skipPrepare (optional) 
     * @param forceRefresh (optional) 
     * @param zoom (optional) 
     * @return Success
     */
    getReportPOST(reportId: string | undefined, clickParams_Click: string | undefined, clickParams_CheckBoxClick: string | undefined, clickParams_TextEdit: string | undefined, clickParams_Text: string | undefined, clickParams_AdvMatrixClick: string | undefined, dialogParams_DialogN: string | undefined, dialogParams_DialogControlName: string | undefined, dialogParams_DialogEventName: string | undefined, dialogParams_DialogData: string | undefined, reportTabParams_SetTab: string | undefined, reportTabParams_CloseTab: string | undefined, reportPageParams_GoTo: string | undefined, reportPageParams_Bookmark: string | undefined, reportPageParams_DetailedReport: string | undefined, reportPageParams_DetailedPage: string | undefined, renderBody: string | undefined, skipPrepare: string | undefined, forceRefresh: string | undefined, zoom: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @return Success
     */
    touchReport(reportId: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class GetReportClient implements IGetReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportId (optional) 
     * @param clickParams_Click (optional) 
     * @param clickParams_CheckBoxClick (optional) 
     * @param clickParams_TextEdit (optional) 
     * @param clickParams_Text (optional) 
     * @param clickParams_AdvMatrixClick (optional) 
     * @param dialogParams_DialogN (optional) 
     * @param dialogParams_DialogControlName (optional) 
     * @param dialogParams_DialogEventName (optional) 
     * @param dialogParams_DialogData (optional) 
     * @param reportTabParams_SetTab (optional) 
     * @param reportTabParams_CloseTab (optional) 
     * @param reportPageParams_GoTo (optional) 
     * @param reportPageParams_Bookmark (optional) 
     * @param reportPageParams_DetailedReport (optional) 
     * @param reportPageParams_DetailedPage (optional) 
     * @param renderBody (optional) 
     * @param skipPrepare (optional) 
     * @param forceRefresh (optional) 
     * @param zoom (optional) 
     * @return Success
     */
    getReportPOST(reportId: string | undefined, clickParams_Click: string | undefined, clickParams_CheckBoxClick: string | undefined, clickParams_TextEdit: string | undefined, clickParams_Text: string | undefined, clickParams_AdvMatrixClick: string | undefined, dialogParams_DialogN: string | undefined, dialogParams_DialogControlName: string | undefined, dialogParams_DialogEventName: string | undefined, dialogParams_DialogData: string | undefined, reportTabParams_SetTab: string | undefined, reportTabParams_CloseTab: string | undefined, reportPageParams_GoTo: string | undefined, reportPageParams_Bookmark: string | undefined, reportPageParams_DetailedReport: string | undefined, reportPageParams_DetailedPage: string | undefined, renderBody: string | undefined, skipPrepare: string | undefined, forceRefresh: string | undefined, zoom: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/preview.getReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (clickParams_Click === null)
            throw new Error("The parameter 'clickParams_Click' cannot be null.");
        else if (clickParams_Click !== undefined)
            url_ += "ClickParams.Click=" + encodeURIComponent("" + clickParams_Click) + "&";
        if (clickParams_CheckBoxClick === null)
            throw new Error("The parameter 'clickParams_CheckBoxClick' cannot be null.");
        else if (clickParams_CheckBoxClick !== undefined)
            url_ += "ClickParams.CheckBoxClick=" + encodeURIComponent("" + clickParams_CheckBoxClick) + "&";
        if (clickParams_TextEdit === null)
            throw new Error("The parameter 'clickParams_TextEdit' cannot be null.");
        else if (clickParams_TextEdit !== undefined)
            url_ += "ClickParams.TextEdit=" + encodeURIComponent("" + clickParams_TextEdit) + "&";
        if (clickParams_Text === null)
            throw new Error("The parameter 'clickParams_Text' cannot be null.");
        else if (clickParams_Text !== undefined)
            url_ += "ClickParams.Text=" + encodeURIComponent("" + clickParams_Text) + "&";
        if (clickParams_AdvMatrixClick === null)
            throw new Error("The parameter 'clickParams_AdvMatrixClick' cannot be null.");
        else if (clickParams_AdvMatrixClick !== undefined)
            url_ += "ClickParams.AdvMatrixClick=" + encodeURIComponent("" + clickParams_AdvMatrixClick) + "&";
        if (dialogParams_DialogN === null)
            throw new Error("The parameter 'dialogParams_DialogN' cannot be null.");
        else if (dialogParams_DialogN !== undefined)
            url_ += "DialogParams.DialogN=" + encodeURIComponent("" + dialogParams_DialogN) + "&";
        if (dialogParams_DialogControlName === null)
            throw new Error("The parameter 'dialogParams_DialogControlName' cannot be null.");
        else if (dialogParams_DialogControlName !== undefined)
            url_ += "DialogParams.DialogControlName=" + encodeURIComponent("" + dialogParams_DialogControlName) + "&";
        if (dialogParams_DialogEventName === null)
            throw new Error("The parameter 'dialogParams_DialogEventName' cannot be null.");
        else if (dialogParams_DialogEventName !== undefined)
            url_ += "DialogParams.DialogEventName=" + encodeURIComponent("" + dialogParams_DialogEventName) + "&";
        if (dialogParams_DialogData === null)
            throw new Error("The parameter 'dialogParams_DialogData' cannot be null.");
        else if (dialogParams_DialogData !== undefined)
            url_ += "DialogParams.DialogData=" + encodeURIComponent("" + dialogParams_DialogData) + "&";
        if (reportTabParams_SetTab === null)
            throw new Error("The parameter 'reportTabParams_SetTab' cannot be null.");
        else if (reportTabParams_SetTab !== undefined)
            url_ += "ReportTabParams.SetTab=" + encodeURIComponent("" + reportTabParams_SetTab) + "&";
        if (reportTabParams_CloseTab === null)
            throw new Error("The parameter 'reportTabParams_CloseTab' cannot be null.");
        else if (reportTabParams_CloseTab !== undefined)
            url_ += "ReportTabParams.CloseTab=" + encodeURIComponent("" + reportTabParams_CloseTab) + "&";
        if (reportPageParams_GoTo === null)
            throw new Error("The parameter 'reportPageParams_GoTo' cannot be null.");
        else if (reportPageParams_GoTo !== undefined)
            url_ += "ReportPageParams.GoTo=" + encodeURIComponent("" + reportPageParams_GoTo) + "&";
        if (reportPageParams_Bookmark === null)
            throw new Error("The parameter 'reportPageParams_Bookmark' cannot be null.");
        else if (reportPageParams_Bookmark !== undefined)
            url_ += "ReportPageParams.Bookmark=" + encodeURIComponent("" + reportPageParams_Bookmark) + "&";
        if (reportPageParams_DetailedReport === null)
            throw new Error("The parameter 'reportPageParams_DetailedReport' cannot be null.");
        else if (reportPageParams_DetailedReport !== undefined)
            url_ += "ReportPageParams.DetailedReport=" + encodeURIComponent("" + reportPageParams_DetailedReport) + "&";
        if (reportPageParams_DetailedPage === null)
            throw new Error("The parameter 'reportPageParams_DetailedPage' cannot be null.");
        else if (reportPageParams_DetailedPage !== undefined)
            url_ += "ReportPageParams.DetailedPage=" + encodeURIComponent("" + reportPageParams_DetailedPage) + "&";
        if (renderBody === null)
            throw new Error("The parameter 'renderBody' cannot be null.");
        else if (renderBody !== undefined)
            url_ += "RenderBody=" + encodeURIComponent("" + renderBody) + "&";
        if (skipPrepare === null)
            throw new Error("The parameter 'skipPrepare' cannot be null.");
        else if (skipPrepare !== undefined)
            url_ += "SkipPrepare=" + encodeURIComponent("" + skipPrepare) + "&";
        if (forceRefresh === null)
            throw new Error("The parameter 'forceRefresh' cannot be null.");
        else if (forceRefresh !== undefined)
            url_ += "ForceRefresh=" + encodeURIComponent("" + forceRefresh) + "&";
        if (zoom === null)
            throw new Error("The parameter 'zoom' cannot be null.");
        else if (zoom !== undefined)
            url_ += "Zoom=" + encodeURIComponent("" + zoom) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReportPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    touchReport(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/preview.touchReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTouchReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTouchReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTouchReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IIntegrationClient {
    /**
     * @return Success
     */
    getToken(target: string): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class IntegrationClient implements IIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getToken(target: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Integration/token/{target}";
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IInventoryStateClient {
    /**
     * @return Success
     */
    getInventoryStates(): Observable<InventoryStateModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class InventoryStateClient implements IInventoryStateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getInventoryStates(): Observable<InventoryStateModel[]> {
        let url_ = this.baseUrl + "/api/InventoryState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryStateModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryStateModel[]>;
        }));
    }

    protected processGetInventoryStates(response: HttpResponseBase): Observable<InventoryStateModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InventoryStateModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryStateModel[]>(null as any);
    }
}

export interface IMaterialPlanningClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getMaterialPlanningGroups(body: MaterialPlannerRequestModel | undefined): Observable<PlannerItemResult>;
    /**
     * @param seedForecastItemId (optional) 
     * @return Success
     */
    getMaterialPlanningItemDetail(seedForecastItemId: number | undefined): Observable<PlannerItemDetail>;
    /**
     * @param body (optional) 
     * @return Success
     */
    assignMaterialGroup(body: PlannerItem | undefined): Observable<PlannerItemDetail>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateDestinationStatus(body: ForecastItemDestinationModel | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class MaterialPlanningClient implements IMaterialPlanningClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMaterialPlanningGroups(body: MaterialPlannerRequestModel | undefined): Observable<PlannerItemResult> {
        let url_ = this.baseUrl + "/api/MaterialPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialPlanningGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialPlanningGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannerItemResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannerItemResult>;
        }));
    }

    protected processGetMaterialPlanningGroups(response: HttpResponseBase): Observable<PlannerItemResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PlannerItemResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlannerItemResult>(null as any);
    }

    /**
     * @param seedForecastItemId (optional) 
     * @return Success
     */
    getMaterialPlanningItemDetail(seedForecastItemId: number | undefined): Observable<PlannerItemDetail> {
        let url_ = this.baseUrl + "/api/MaterialPlanning/GetPlannerItemDetail?";
        if (seedForecastItemId === null)
            throw new Error("The parameter 'seedForecastItemId' cannot be null.");
        else if (seedForecastItemId !== undefined)
            url_ += "seedForecastItemId=" + encodeURIComponent("" + seedForecastItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialPlanningItemDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialPlanningItemDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannerItemDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannerItemDetail>;
        }));
    }

    protected processGetMaterialPlanningItemDetail(response: HttpResponseBase): Observable<PlannerItemDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PlannerItemDetail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlannerItemDetail>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignMaterialGroup(body: PlannerItem | undefined): Observable<PlannerItemDetail> {
        let url_ = this.baseUrl + "/api/MaterialPlanning/AssignMaterialGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMaterialGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMaterialGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannerItemDetail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannerItemDetail>;
        }));
    }

    protected processAssignMaterialGroup(response: HttpResponseBase): Observable<PlannerItemDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PlannerItemDetail.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlannerItemDetail>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDestinationStatus(body: ForecastItemDestinationModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/MaterialPlanning/UpdateDestinationStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDestinationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDestinationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateDestinationStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IMaterialPurposeClient {
    /**
     * @return Success
     */
    getMaterialPurpose(): Observable<MaterialPurposeModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class MaterialPurposeClient implements IMaterialPurposeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getMaterialPurpose(): Observable<MaterialPurposeModel[]> {
        let url_ = this.baseUrl + "/api/MaterialPurpose";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialPurpose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialPurpose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialPurposeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialPurposeModel[]>;
        }));
    }

    protected processGetMaterialPurpose(response: HttpResponseBase): Observable<MaterialPurposeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialPurposeModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialPurposeModel[]>(null as any);
    }
}

export interface IOrderStatusClient {
    /**
     * @return Success
     */
    getOrderStatus(): Observable<OrderStatusModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderStatusClient implements IOrderStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getOrderStatus(): Observable<OrderStatusModel[]> {
        let url_ = this.baseUrl + "/api/OrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStatusModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStatusModel[]>;
        }));
    }

    protected processGetOrderStatus(response: HttpResponseBase): Observable<OrderStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderStatusModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStatusModel[]>(null as any);
    }
}

export interface IOrderTypeClient {
    /**
     * @return Success
     */
    getOrderType(): Observable<OrderTypeModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderTypeClient implements IOrderTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getOrderType(): Observable<OrderTypeModel[]> {
        let url_ = this.baseUrl + "/api/OrderType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderTypeModel[]>;
        }));
    }

    protected processGetOrderType(response: HttpResponseBase): Observable<OrderTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderTypeModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderTypeModel[]>(null as any);
    }
}

export interface IPrintReportClient {
    /**
     * @param reportId (optional) 
     * @param printMode (optional) 
     * @return Success
     */
    printReport(reportId: string | undefined, printMode: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class PrintReportClient implements IPrintReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportId (optional) 
     * @param printMode (optional) 
     * @return Success
     */
    printReport(reportId: string | undefined, printMode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/preview.printReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (printMode === null)
            throw new Error("The parameter 'printMode' cannot be null.");
        else if (printMode !== undefined)
            url_ += "PrintMode=" + encodeURIComponent("" + printMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrintReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IProcurementClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderItems(body: OrderSearchRequest | undefined): Observable<OrderItemResult>;
    /**
     * @param body (optional) 
     * @return Success
     */
    assignMaterialGroup2(body: OrderItemModel | undefined): Observable<OrderItemModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsManufactured(body: OrderItemModel | undefined): Observable<OrderItemModel>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderItem(id: number | undefined): Observable<OrderItemModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateProcurements(body: OrderItemModel[] | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateOrderDetails(body: OrderItemModel | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateOrderItemComment(body: OrderItemCommentModel | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createOrder(body: OrderItemModel | undefined): Observable<OrderItemModel>;
    /**
     * @return Success
     */
    getReceiptStatuses(): Observable<ReceiptStatusModel[]>;
    /**
     * @return Success
     */
    getReportGET4(): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ProcurementClient implements IProcurementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderItems(body: OrderSearchRequest | undefined): Observable<OrderItemResult> {
        let url_ = this.baseUrl + "/api/Procurement/GetOrderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemResult>;
        }));
    }

    protected processGetOrderItems(response: HttpResponseBase): Observable<OrderItemResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrderItemResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignMaterialGroup2(body: OrderItemModel | undefined): Observable<OrderItemModel> {
        let url_ = this.baseUrl + "/api/Procurement/AssignMaterialGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMaterialGroup2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMaterialGroup2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemModel>;
        }));
    }

    protected processAssignMaterialGroup2(response: HttpResponseBase): Observable<OrderItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrderItemModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500, _mappings);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsManufactured(body: OrderItemModel | undefined): Observable<OrderItemModel> {
        let url_ = this.baseUrl + "/api/Procurement/UpdateManufactureStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIsManufactured(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIsManufactured(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemModel>;
        }));
    }

    protected processUpdateIsManufactured(response: HttpResponseBase): Observable<OrderItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrderItemModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderItem(id: number | undefined): Observable<OrderItemModel> {
        let url_ = this.baseUrl + "/api/Procurement/GetOrderItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemModel>;
        }));
    }

    protected processGetOrderItem(response: HttpResponseBase): Observable<OrderItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = OrderItemModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateProcurements(body: OrderItemModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Procurement/UpdateProcurements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProcurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProcurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProcurements(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateOrderDetails(body: OrderItemModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Procurement/UpdateOrderDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateOrderItemComment(body: OrderItemCommentModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Procurement/UpdateOrderItemComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderItemComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderItemComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderItemComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createOrder(body: OrderItemModel | undefined): Observable<OrderItemModel> {
        let url_ = this.baseUrl + "/api/Procurement/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemModel>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<OrderItemModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = OrderItemModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemModel>(null as any);
    }

    /**
     * @return Success
     */
    getReceiptStatuses(): Observable<ReceiptStatusModel[]> {
        let url_ = this.baseUrl + "/api/Procurement/GetReceiptStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptStatusModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptStatusModel[]>;
        }));
    }

    protected processGetReceiptStatuses(response: HttpResponseBase): Observable<ReceiptStatusModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReceiptStatusModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptStatusModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getReportGET4(): Observable<void> {
        let url_ = this.baseUrl + "/api/Procurement/GetProcurementReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportGET4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportGET4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReportGET4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IQuantityUomClient {
    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    get3(enabledOnly: boolean | undefined): Observable<QuantityUnitOfMeasureModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    put3(body: QuantityUnitOfMeasureModel | undefined): Observable<QuantityUnitOfMeasureModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    post2(body: QuantityUnitOfMeasureModel | undefined): Observable<QuantityUnitOfMeasureModel>;
    /**
     * @param uomDisplay (optional) 
     * @return Success
     */
    checkDuplicate2(uomDisplay: string | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class QuantityUomClient implements IQuantityUomClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    get3(enabledOnly: boolean | undefined): Observable<QuantityUnitOfMeasureModel[]> {
        let url_ = this.baseUrl + "/api/QuantityUom?";
        if (enabledOnly === null)
            throw new Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuantityUnitOfMeasureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuantityUnitOfMeasureModel[]>;
        }));
    }

    protected processGet3(response: HttpResponseBase): Observable<QuantityUnitOfMeasureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(QuantityUnitOfMeasureModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuantityUnitOfMeasureModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    put3(body: QuantityUnitOfMeasureModel | undefined): Observable<QuantityUnitOfMeasureModel> {
        let url_ = this.baseUrl + "/api/QuantityUom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuantityUnitOfMeasureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuantityUnitOfMeasureModel>;
        }));
    }

    protected processPut3(response: HttpResponseBase): Observable<QuantityUnitOfMeasureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = QuantityUnitOfMeasureModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuantityUnitOfMeasureModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post2(body: QuantityUnitOfMeasureModel | undefined): Observable<QuantityUnitOfMeasureModel> {
        let url_ = this.baseUrl + "/api/QuantityUom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuantityUnitOfMeasureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuantityUnitOfMeasureModel>;
        }));
    }

    protected processPost2(response: HttpResponseBase): Observable<QuantityUnitOfMeasureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = QuantityUnitOfMeasureModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuantityUnitOfMeasureModel>(null as any);
    }

    /**
     * @param uomDisplay (optional) 
     * @return Success
     */
    checkDuplicate2(uomDisplay: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/QuantityUom/CheckDuplicate?";
        if (uomDisplay === null)
            throw new Error("The parameter 'uomDisplay' cannot be null.");
        else if (uomDisplay !== undefined)
            url_ += "UomDisplay=" + encodeURIComponent("" + uomDisplay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuplicate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuplicate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckDuplicate2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IRawMaterialsClient {
    /**
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param body (optional) 
     * @return Success
     */
    getRawMaterialInfo(pageSize: number | undefined, pageIndex: number | undefined, body: RawMaterialFilterModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    getRawMaterialProductLocations(): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createDelegateDesignation(body: RawMaterialDelegateDesignationModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    getAllRawMaterialRequestStatus(): Observable<void>;
    /**
     * @return Success
     */
    getRawMaterialProductionLocationById(id: number): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateRawMaterialProductionLocationAndOwner(body: RawMaterialProductionModel | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateRawMaterialStatus(body: RawMaterialProductionModel | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    saveRawMaterialComposition(body: RawMaterialCompositionModel[] | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    updateRawMaterialCancellation(body: MaterialCompositionDto[] | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    cancelNotification(body: CancelNotificationRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createForecastItem2(body: ForecastItemModel[] | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateRawMaterialShippingAddress(body: RawMaterialShippingAddressModel | undefined): Observable<void>;
    /**
     * @return Created
     */
    updateRmrStatusToShippedFromAlchemist(cpssRequestNumber: string): Observable<void>;
    /**
     * @param programNumber (optional) 
     * @return Created
     */
    cancelFormulationRequest(programNumber: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RawMaterialsClient implements IRawMaterialsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param body (optional) 
     * @return Success
     */
    getRawMaterialInfo(pageSize: number | undefined, pageIndex: number | undefined, body: RawMaterialFilterModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/rawMaterialInfo?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawMaterialInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawMaterialInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRawMaterialInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRawMaterialProductLocations(): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/productLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawMaterialProductLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawMaterialProductLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRawMaterialProductLocations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createDelegateDesignation(body: RawMaterialDelegateDesignationModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/delegateDesignation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDelegateDesignation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDelegateDesignation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDelegateDesignation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllRawMaterialRequestStatus(): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/rawMaterialRequestStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRawMaterialRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRawMaterialRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAllRawMaterialRequestStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRawMaterialProductionLocationById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/productionLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRawMaterialProductionLocationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRawMaterialProductionLocationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRawMaterialProductionLocationById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRawMaterialProductionLocationAndOwner(body: RawMaterialProductionModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/updateProductionLocationAndOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRawMaterialProductionLocationAndOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRawMaterialProductionLocationAndOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRawMaterialProductionLocationAndOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRawMaterialStatus(body: RawMaterialProductionModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/updateRawMaterialStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRawMaterialStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRawMaterialStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRawMaterialStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    saveRawMaterialComposition(body: RawMaterialCompositionModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/saveRawMaterialComposition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRawMaterialComposition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRawMaterialComposition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveRawMaterialComposition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateRawMaterialCancellation(body: MaterialCompositionDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/updateRawMaterialCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRawMaterialCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRawMaterialCancellation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRawMaterialCancellation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    cancelNotification(body: CancelNotificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/cancelNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createForecastItem2(body: ForecastItemModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/createForecastItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForecastItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForecastItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateForecastItem2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRawMaterialShippingAddress(body: RawMaterialShippingAddressModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/updateShippingAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRawMaterialShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRawMaterialShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRawMaterialShippingAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Created
     */
    updateRmrStatusToShippedFromAlchemist(cpssRequestNumber: string): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/updateRmrStatusToShippedFromAlchemist/{cpssRequestNumber}";
        if (cpssRequestNumber === undefined || cpssRequestNumber === null)
            throw new Error("The parameter 'cpssRequestNumber' must be defined.");
        url_ = url_.replace("{cpssRequestNumber}", encodeURIComponent("" + cpssRequestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRmrStatusToShippedFromAlchemist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRmrStatusToShippedFromAlchemist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRmrStatusToShippedFromAlchemist(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param programNumber (optional) 
     * @return Created
     */
    cancelFormulationRequest(programNumber: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RawMaterials/cancelFormulationRequest?";
        if (programNumber === null)
            throw new Error("The parameter 'programNumber' cannot be null.");
        else if (programNumber !== undefined)
            url_ += "programNumber=" + encodeURIComponent("" + programNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelFormulationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelFormulationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelFormulationRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IReservationClient {
    /**
     * @return Success
     */
    reconciliationReport(repoName: string, materialId: string, uom: string, materialName: string): Observable<void>;
    /**
     * @return Success
     */
    reconcileReservations(repoName: string, materialId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ReservationClient implements IReservationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    reconciliationReport(repoName: string, materialId: string, uom: string, materialName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Reservation/ReconciliationReport/{repoName}/{materialId}/{uom}/{materialName}";
        if (repoName === undefined || repoName === null)
            throw new Error("The parameter 'repoName' must be defined.");
        url_ = url_.replace("{repoName}", encodeURIComponent("" + repoName));
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (uom === undefined || uom === null)
            throw new Error("The parameter 'uom' must be defined.");
        url_ = url_.replace("{uom}", encodeURIComponent("" + uom));
        if (materialName === undefined || materialName === null)
            throw new Error("The parameter 'materialName' must be defined.");
        url_ = url_.replace("{materialName}", encodeURIComponent("" + materialName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconciliationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconciliationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReconciliationReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    reconcileReservations(repoName: string, materialId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Reservation/ReconcileReservations/{repoName}/{materialId}";
        if (repoName === undefined || repoName === null)
            throw new Error("The parameter 'repoName' must be defined.");
        url_ = url_.replace("{repoName}", encodeURIComponent("" + repoName));
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReconcileReservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReconcileReservations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReconcileReservations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IResourcesClient {
    /**
     * @param resourceName (optional) 
     * @param contentType (optional) 
     * @return Success
     */
    getResource(resourceName: string | undefined, contentType: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ResourcesClient implements IResourcesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param resourceName (optional) 
     * @param contentType (optional) 
     * @return Success
     */
    getResource(resourceName: string | undefined, contentType: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/resources.getResource?";
        if (resourceName === null)
            throw new Error("The parameter 'resourceName' cannot be null.");
        else if (resourceName !== undefined)
            url_ += "resourceName=" + encodeURIComponent("" + resourceName) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetResource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRoleClient {
    /**
     * @return Success
     */
    getRoles(): Observable<RoleModel[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postRole(body: RoleModel | undefined): Observable<RoleModel>;
    /**
     * @return Success
     */
    getRole(id: number): Observable<RoleModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    putRole(id: number, body: RoleModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    deleteRole(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleModel[]> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RoleModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postRole(body: RoleModel | undefined): Observable<RoleModel> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel>;
        }));
    }

    protected processPostRole(response: HttpResponseBase): Observable<RoleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = RoleModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel>(null as any);
    }

    /**
     * @return Success
     */
    getRole(id: number): Observable<RoleModel> {
        let url_ = this.baseUrl + "/api/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleModel>;
        }));
    }

    protected processGetRole(response: HttpResponseBase): Observable<RoleModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RoleModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    putRole(id: number, body: RoleModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISampleInventoryLocationClient {
    /**
     * @return Success
     */
    getSampleInventoryLocations(): Observable<SampleInventoryLocationModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SampleInventoryLocationClient implements ISampleInventoryLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getSampleInventoryLocations(): Observable<SampleInventoryLocationModel[]> {
        let url_ = this.baseUrl + "/api/SampleInventoryLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleInventoryLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleInventoryLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SampleInventoryLocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SampleInventoryLocationModel[]>;
        }));
    }

    protected processGetSampleInventoryLocations(response: HttpResponseBase): Observable<SampleInventoryLocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SampleInventoryLocationModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SampleInventoryLocationModel[]>(null as any);
    }
}

export interface ISampleShopClient {
    /**
     * @return Success
     */
    getForecastDestinationsGET(emailId: string): Observable<ForecastItemLocationModel[]>;
    /**
     * @return Success
     */
    getForecastDestination(locationId: number): Observable<ForecastItemLocationModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getForecastDestinationsPOST(body: number[] | undefined): Observable<ExpiredForecastItemModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SampleShopClient implements ISampleShopClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getForecastDestinationsGET(emailId: string): Observable<ForecastItemLocationModel[]> {
        let url_ = this.baseUrl + "/api/SampleShop/GetForecastDestinations/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastDestinationsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastDestinationsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemLocationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemLocationModel[]>;
        }));
    }

    protected processGetForecastDestinationsGET(response: HttpResponseBase): Observable<ForecastItemLocationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ForecastItemLocationModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemLocationModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getForecastDestination(locationId: number): Observable<ForecastItemLocationModel> {
        let url_ = this.baseUrl + "/api/SampleShop/GetForecastDestination/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastItemLocationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastItemLocationModel>;
        }));
    }

    protected processGetForecastDestination(response: HttpResponseBase): Observable<ForecastItemLocationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastItemLocationModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastItemLocationModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForecastDestinationsPOST(body: number[] | undefined): Observable<ExpiredForecastItemModel[]> {
        let url_ = this.baseUrl + "/api/SampleShop/GetExpiredForecasts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForecastDestinationsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForecastDestinationsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExpiredForecastItemModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExpiredForecastItemModel[]>;
        }));
    }

    protected processGetForecastDestinationsPOST(response: HttpResponseBase): Observable<ExpiredForecastItemModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExpiredForecastItemModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExpiredForecastItemModel[]>(null as any);
    }
}

export interface ISearchClient {
    /**
     * @param body (optional) 
     * @return Created
     */
    createSearchFormula(body: SearchFormulaModel | undefined): Observable<SearchFormulaModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    updateSearchFormula(id: number, body: SearchFormulaModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    getSearchFormula(id: number): Observable<SearchFormulaModel>;
    /**
     * @return Success
     */
    getSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]>;
    /**
     * @return Success
     */
    getProcurementSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]>;
    /**
     * @return Success
     */
    getSubmittedForecastSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]>;
    /**
     * @return Success
     */
    getFormulationProductionSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SearchClient implements ISearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createSearchFormula(body: SearchFormulaModel | undefined): Observable<SearchFormulaModel> {
        let url_ = this.baseUrl + "/api/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSearchFormula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSearchFormula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFormulaModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFormulaModel>;
        }));
    }

    protected processCreateSearchFormula(response: HttpResponseBase): Observable<SearchFormulaModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = SearchFormulaModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFormulaModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateSearchFormula(id: number, body: SearchFormulaModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Search/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSearchFormula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSearchFormula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSearchFormula(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getSearchFormula(id: number): Observable<SearchFormulaModel> {
        let url_ = this.baseUrl + "/api/Search/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchFormula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchFormula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFormulaModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFormulaModel>;
        }));
    }

    protected processGetSearchFormula(response: HttpResponseBase): Observable<SearchFormulaModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = SearchFormulaModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFormulaModel>(null as any);
    }

    /**
     * @return Success
     */
    getSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]> {
        let url_ = this.baseUrl + "/api/Search/GetSearchFormulas/{ownerId}";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchFormulas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchFormulas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFormulaModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFormulaModel[]>;
        }));
    }

    protected processGetSearchFormulas(response: HttpResponseBase): Observable<SearchFormulaModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SearchFormulaModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFormulaModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getProcurementSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]> {
        let url_ = this.baseUrl + "/api/Search/GetProcurementSearchFormulas/{ownerId}";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcurementSearchFormulas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcurementSearchFormulas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFormulaModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFormulaModel[]>;
        }));
    }

    protected processGetProcurementSearchFormulas(response: HttpResponseBase): Observable<SearchFormulaModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SearchFormulaModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFormulaModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getSubmittedForecastSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]> {
        let url_ = this.baseUrl + "/api/Search/GetSubmittedForecastSearchFormulas/{ownerId}";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmittedForecastSearchFormulas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedForecastSearchFormulas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFormulaModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFormulaModel[]>;
        }));
    }

    protected processGetSubmittedForecastSearchFormulas(response: HttpResponseBase): Observable<SearchFormulaModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SearchFormulaModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFormulaModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getFormulationProductionSearchFormulas(ownerId: number): Observable<SearchFormulaModel[]> {
        let url_ = this.baseUrl + "/api/Search/GetFormulationProductionSearchFormulas/{ownerId}";
        if (ownerId === undefined || ownerId === null)
            throw new Error("The parameter 'ownerId' must be defined.");
        url_ = url_.replace("{ownerId}", encodeURIComponent("" + ownerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormulationProductionSearchFormulas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulationProductionSearchFormulas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFormulaModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFormulaModel[]>;
        }));
    }

    protected processGetFormulationProductionSearchFormulas(response: HttpResponseBase): Observable<SearchFormulaModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SearchFormulaModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchFormulaModel[]>(null as any);
    }
}

export interface IServiceClient {
    /**
     * @param reportId (optional) 
     * @param click (optional) 
     * @return Success
     */
    textEditForm(reportId: string | undefined, click: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ServiceClient implements IServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reportId (optional) 
     * @param click (optional) 
     * @return Success
     */
    textEditForm(reportId: string | undefined, click: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/preview.textEditForm?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (click === null)
            throw new Error("The parameter 'click' cannot be null.");
        else if (click !== undefined)
            url_ += "Click=" + encodeURIComponent("" + click) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTextEditForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextEditForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTextEditForm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IShipmentDefectClient {
    /**
     * @return Success
     */
    getShipmentDefects(): Observable<ShipmentDefectModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ShipmentDefectClient implements IShipmentDefectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getShipmentDefects(): Observable<ShipmentDefectModel[]> {
        let url_ = this.baseUrl + "/api/ShipmentDefect/GetShipmentDefects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShipmentDefects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShipmentDefects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShipmentDefectModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShipmentDefectModel[]>;
        }));
    }

    protected processGetShipmentDefects(response: HttpResponseBase): Observable<ShipmentDefectModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShipmentDefectModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentDefectModel[]>(null as any);
    }
}

export interface IUnitOfMeasureClient {
    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    getUnitOfMeasures(enabledOnly: boolean | undefined): Observable<UnitOfMeasureModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addUnitOfMeasure(body: UnitOfMeasureModel | undefined): Observable<UnitOfMeasureModel>;
}

@Injectable({
    providedIn: 'root'
})
export class UnitOfMeasureClient implements IUnitOfMeasureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param enabledOnly (optional) 
     * @return Success
     */
    getUnitOfMeasures(enabledOnly: boolean | undefined): Observable<UnitOfMeasureModel[]> {
        let url_ = this.baseUrl + "/api/UnitOfMeasure/GetUnitOfMeasures?";
        if (enabledOnly === null)
            throw new Error("The parameter 'enabledOnly' cannot be null.");
        else if (enabledOnly !== undefined)
            url_ += "enabledOnly=" + encodeURIComponent("" + enabledOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnitOfMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnitOfMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitOfMeasureModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitOfMeasureModel[]>;
        }));
    }

    protected processGetUnitOfMeasures(response: HttpResponseBase): Observable<UnitOfMeasureModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UnitOfMeasureModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnitOfMeasureModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUnitOfMeasure(body: UnitOfMeasureModel | undefined): Observable<UnitOfMeasureModel> {
        let url_ = this.baseUrl + "/api/UnitOfMeasure/AddUnitOfMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUnitOfMeasure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUnitOfMeasure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitOfMeasureModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitOfMeasureModel>;
        }));
    }

    protected processAddUnitOfMeasure(response: HttpResponseBase): Observable<UnitOfMeasureModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UnitOfMeasureModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnitOfMeasureModel>(null as any);
    }
}

export interface IUserClient {
    /**
     * @return Success
     */
    getFunctionsAll(): Observable<JobFunction[]>;
    /**
     * @return Success
     */
    getUsers(): Observable<UserModel[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postUser(body: UserModel | undefined): Observable<UserModel>;
    /**
     * @return Success
     */
    getMatchingUsers(match: string): Observable<UserModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getUsersInRoles(body: string[] | undefined): Observable<UserModel[]>;
    /**
     * @return Success
     */
    updateMaterialApprover(emailId: string): Observable<UserModel>;
    /**
     * @return Success
     */
    getUser(id: number): Observable<UserModel>;
    /**
     * @param body (optional) 
     * @return No Content
     */
    putUser(id: number, body: UserModel | undefined): Observable<void>;
    /**
     * @return Success
     */
    deleteUser(id: number): Observable<void>;
    /**
     * @return Success
     */
    getADUser(userId: string): Observable<UserModel>;
    /**
     * @return Success
     */
    getByEmailId(email: string): Observable<UserModel>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getFunctionsAll(): Observable<JobFunction[]> {
        let url_ = this.baseUrl + "/api/User/Functions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFunctionsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFunctionsAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobFunction[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobFunction[]>;
        }));
    }

    protected processGetFunctionsAll(response: HttpResponseBase): Observable<JobFunction[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(JobFunction.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobFunction[]>(null as any);
    }

    /**
     * @return Success
     */
    getUsers(): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postUser(body: UserModel | undefined): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processPostUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result201 = UserModel.fromJS(resultData201, _mappings);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409, _mappings);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    /**
     * @return Success
     */
    getMatchingUsers(match: string): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetMatchingUsers/{match}";
        if (match === undefined || match === null)
            throw new Error("The parameter 'match' must be defined.");
        url_ = url_.replace("{match}", encodeURIComponent("" + match));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetMatchingUsers(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsersInRoles(body: string[] | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/User/GetUsersInRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersInRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersInRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUsersInRoles(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }

    /**
     * @return Success
     */
    updateMaterialApprover(emailId: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/UpdateMaterialApprover/{emailId}";
        if (emailId === undefined || emailId === null)
            throw new Error("The parameter 'emailId' must be defined.");
        url_ = url_.replace("{emailId}", encodeURIComponent("" + emailId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMaterialApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processUpdateMaterialApprover(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    /**
     * @return Success
     */
    getUser(id: number): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    putUser(id: number, body: UserModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getADUser(userId: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/AD/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetADUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetADUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetADUser(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }

    /**
     * @return Success
     */
    getByEmailId(email: string): Observable<UserModel> {
        let url_ = this.baseUrl + "/api/User/email/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByEmailId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByEmailId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel>;
        }));
    }

    protected processGetByEmailId(response: HttpResponseBase): Observable<UserModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel>(null as any);
    }
}

export interface IUtilsClient {
    /**
     * @param name (optional) 
     * @return Success
     */
    getMSChartTemplate(name: string | undefined): Observable<void>;
    /**
     * @param name (optional) 
     * @return Success
     */
    getComponentProperties(name: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @return Success
     */
    getConfig(reportId: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @return Success
     */
    getFunctions(reportId: string | undefined): Observable<void>;
    /**
     * @param reportId (optional) 
     * @return Success
     */
    getDesignerObjectPreview(reportId: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class UtilsClient implements IUtilsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getMSChartTemplate(name: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.objects/mschart/template?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMSChartTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMSChartTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetMSChartTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getComponentProperties(name: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getComponentProperties?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComponentProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComponentProperties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetComponentProperties(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getConfig(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getConfig?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getFunctions(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.getFunctions?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetFunctions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getDesignerObjectPreview(reportId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/_fr/designer.objects/preview?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDesignerObjectPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignerObjectPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetDesignerObjectPreview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AltForecastItemActiveIngredientModel implements IAltForecastItemActiveIngredientModel {
    id?: number;
    activeIngredient?: string | undefined;
    forecastItemId?: number | undefined;
    forecastItemName?: string | undefined;
    concentrationUomId?: number | undefined;
    concentrationUomName?: string | undefined;
    concentrationValue?: number;
    concentrationInPrimaryUom?: string | undefined;
    concentrationInSecondaryUom?: string | undefined;

    constructor(data?: IAltForecastItemActiveIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeIngredient = _data["activeIngredient"];
            this.forecastItemId = _data["forecastItemId"];
            this.forecastItemName = _data["forecastItemName"];
            this.concentrationUomId = _data["concentrationUomId"];
            this.concentrationUomName = _data["concentrationUomName"];
            this.concentrationValue = _data["concentrationValue"];
            this.concentrationInPrimaryUom = _data["concentrationInPrimaryUom"];
            this.concentrationInSecondaryUom = _data["concentrationInSecondaryUom"];
        }
    }

    static fromJS(data: any, _mappings?: any): AltForecastItemActiveIngredientModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AltForecastItemActiveIngredientModel>(data, _mappings, AltForecastItemActiveIngredientModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeIngredient"] = this.activeIngredient;
        data["forecastItemId"] = this.forecastItemId;
        data["forecastItemName"] = this.forecastItemName;
        data["concentrationUomId"] = this.concentrationUomId;
        data["concentrationUomName"] = this.concentrationUomName;
        data["concentrationValue"] = this.concentrationValue;
        data["concentrationInPrimaryUom"] = this.concentrationInPrimaryUom;
        data["concentrationInSecondaryUom"] = this.concentrationInSecondaryUom;
        return data;
    }
}

export interface IAltForecastItemActiveIngredientModel {
    id?: number;
    activeIngredient?: string | undefined;
    forecastItemId?: number | undefined;
    forecastItemName?: string | undefined;
    concentrationUomId?: number | undefined;
    concentrationUomName?: string | undefined;
    concentrationValue?: number;
    concentrationInPrimaryUom?: string | undefined;
    concentrationInSecondaryUom?: string | undefined;
}

export class ApproveForecastModel implements IApproveForecastModel {
    forecastItemId?: number;
    isApproved?: boolean;
    approvedByUserId?: number;
    comment?: string | undefined;
    approvalTimeStamp?: Date;

    constructor(data?: IApproveForecastModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.forecastItemId = _data["forecastItemId"];
            this.isApproved = _data["isApproved"];
            this.approvedByUserId = _data["approvedByUserId"];
            this.comment = _data["comment"];
            this.approvalTimeStamp = _data["approvalTimeStamp"] ? new Date(_data["approvalTimeStamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ApproveForecastModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApproveForecastModel>(data, _mappings, ApproveForecastModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastItemId"] = this.forecastItemId;
        data["isApproved"] = this.isApproved;
        data["approvedByUserId"] = this.approvedByUserId;
        data["comment"] = this.comment;
        data["approvalTimeStamp"] = this.approvalTimeStamp ? this.approvalTimeStamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApproveForecastModel {
    forecastItemId?: number;
    isApproved?: boolean;
    approvedByUserId?: number;
    comment?: string | undefined;
    approvalTimeStamp?: Date;
}

export class CancelNotificationRequest implements ICancelNotificationRequest {
    materialCompositions?: MaterialCompositionDto[] | undefined;
    productionOwnerEmail?: string | undefined;

    constructor(data?: ICancelNotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["materialCompositions"])) {
                this.materialCompositions = [] as any;
                for (let item of _data["materialCompositions"])
                    this.materialCompositions.push(MaterialCompositionDto.fromJS(item, _mappings));
            }
            this.productionOwnerEmail = _data["productionOwnerEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): CancelNotificationRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CancelNotificationRequest>(data, _mappings, CancelNotificationRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materialCompositions)) {
            data["materialCompositions"] = [];
            for (let item of this.materialCompositions)
                data["materialCompositions"].push(item.toJSON());
        }
        data["productionOwnerEmail"] = this.productionOwnerEmail;
        return data;
    }
}

export interface ICancelNotificationRequest {
    materialCompositions?: MaterialCompositionDto[] | undefined;
    productionOwnerEmail?: string | undefined;
}

export class ConcentrationUomModel implements IConcentrationUomModel {
    id?: number;
    uomDisplay?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
    sortOrder?: number;

    constructor(data?: IConcentrationUomModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uomDisplay = _data["uomDisplay"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConcentrationUomModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConcentrationUomModel>(data, _mappings, ConcentrationUomModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uomDisplay"] = this.uomDisplay;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IConcentrationUomModel {
    id?: number;
    uomDisplay?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
    sortOrder?: number;
}

export class CountryModel implements ICountryModel {
    id?: number;
    displayName?: string | undefined;
    isProhibited?: boolean;
    countryCode?: string | undefined;
    isRegion?: boolean;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isProhibited = _data["isProhibited"];
            this.countryCode = _data["countryCode"];
            this.isRegion = _data["isRegion"];
        }
    }

    static fromJS(data: any, _mappings?: any): CountryModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CountryModel>(data, _mappings, CountryModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isProhibited"] = this.isProhibited;
        data["countryCode"] = this.countryCode;
        data["isRegion"] = this.isRegion;
        return data;
    }
}

export interface ICountryModel {
    id?: number;
    displayName?: string | undefined;
    isProhibited?: boolean;
    countryCode?: string | undefined;
    isRegion?: boolean;
}

export class CustomFilterModel implements ICustomFilterModel {
    forecastNumber?: number | undefined;
    country?: number | undefined;
    materialName?: string | undefined;
    statusList?: number[] | undefined;
    reviewerId?: number | undefined;
    orderBy?: string | undefined;
    program?: string | undefined;
    forecasterId?: number | undefined;
    isDesc?: boolean;

    constructor(data?: ICustomFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.forecastNumber = _data["forecastNumber"];
            this.country = _data["country"];
            this.materialName = _data["materialName"];
            if (Array.isArray(_data["statusList"])) {
                this.statusList = [] as any;
                for (let item of _data["statusList"])
                    this.statusList.push(item);
            }
            this.reviewerId = _data["reviewerId"];
            this.orderBy = _data["orderBy"];
            this.program = _data["program"];
            this.forecasterId = _data["forecasterId"];
            this.isDesc = _data["isDesc"];
        }
    }

    static fromJS(data: any, _mappings?: any): CustomFilterModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CustomFilterModel>(data, _mappings, CustomFilterModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastNumber"] = this.forecastNumber;
        data["country"] = this.country;
        data["materialName"] = this.materialName;
        if (Array.isArray(this.statusList)) {
            data["statusList"] = [];
            for (let item of this.statusList)
                data["statusList"].push(item);
        }
        data["reviewerId"] = this.reviewerId;
        data["orderBy"] = this.orderBy;
        data["program"] = this.program;
        data["forecasterId"] = this.forecasterId;
        data["isDesc"] = this.isDesc;
        return data;
    }
}

export interface ICustomFilterModel {
    forecastNumber?: number | undefined;
    country?: number | undefined;
    materialName?: string | undefined;
    statusList?: number[] | undefined;
    reviewerId?: number | undefined;
    orderBy?: string | undefined;
    program?: string | undefined;
    forecasterId?: number | undefined;
    isDesc?: boolean;
}

export class DashboardModel implements IDashboardModel {
    stateName?: string | undefined;
    count?: number;

    constructor(data?: IDashboardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.stateName = _data["stateName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any, _mappings?: any): DashboardModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DashboardModel>(data, _mappings, DashboardModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateName"] = this.stateName;
        data["count"] = this.count;
        return data;
    }
}

export interface IDashboardModel {
    stateName?: string | undefined;
    count?: number;
}

export class ExpiredForecastItemModel implements IExpiredForecastItemModel {
    forecastId?: number;
    productName?: string | undefined;
    quantity?: number;
    requestedUom?: string | undefined;
    requestedUomId?: number;
    forecastEndDate?: Date | undefined;
    forecastLocationId?: number;
    inventoryLocationId?: number;
    isExpired?: boolean;

    constructor(data?: IExpiredForecastItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.forecastId = _data["forecastId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.requestedUom = _data["requestedUom"];
            this.requestedUomId = _data["requestedUomId"];
            this.forecastEndDate = _data["forecastEndDate"] ? new Date(_data["forecastEndDate"].toString()) : <any>undefined;
            this.forecastLocationId = _data["forecastLocationId"];
            this.inventoryLocationId = _data["inventoryLocationId"];
            this.isExpired = _data["isExpired"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExpiredForecastItemModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExpiredForecastItemModel>(data, _mappings, ExpiredForecastItemModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastId"] = this.forecastId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["requestedUom"] = this.requestedUom;
        data["requestedUomId"] = this.requestedUomId;
        data["forecastEndDate"] = this.forecastEndDate ? this.forecastEndDate.toISOString() : <any>undefined;
        data["forecastLocationId"] = this.forecastLocationId;
        data["inventoryLocationId"] = this.inventoryLocationId;
        data["isExpired"] = this.isExpired;
        return data;
    }
}

export interface IExpiredForecastItemModel {
    forecastId?: number;
    productName?: string | undefined;
    quantity?: number;
    requestedUom?: string | undefined;
    requestedUomId?: number;
    forecastEndDate?: Date | undefined;
    forecastLocationId?: number;
    inventoryLocationId?: number;
    isExpired?: boolean;
}

export class ForecastItemActiveIngredientModel implements IForecastItemActiveIngredientModel {
    id?: number;
    activeIngredient?: string | undefined;
    forecastItemId?: number | undefined;
    forecastItemName?: string | undefined;
    concentrationUomId?: number | undefined;
    concentrationUomName?: string | undefined;
    concentrationValue?: number;
    concentrationInPrimaryUom?: string | undefined;
    concentrationInSecondaryUom?: string | undefined;

    constructor(data?: IForecastItemActiveIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeIngredient = _data["activeIngredient"];
            this.forecastItemId = _data["forecastItemId"];
            this.forecastItemName = _data["forecastItemName"];
            this.concentrationUomId = _data["concentrationUomId"];
            this.concentrationUomName = _data["concentrationUomName"];
            this.concentrationValue = _data["concentrationValue"];
            this.concentrationInPrimaryUom = _data["concentrationInPrimaryUom"];
            this.concentrationInSecondaryUom = _data["concentrationInSecondaryUom"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemActiveIngredientModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemActiveIngredientModel>(data, _mappings, ForecastItemActiveIngredientModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeIngredient"] = this.activeIngredient;
        data["forecastItemId"] = this.forecastItemId;
        data["forecastItemName"] = this.forecastItemName;
        data["concentrationUomId"] = this.concentrationUomId;
        data["concentrationUomName"] = this.concentrationUomName;
        data["concentrationValue"] = this.concentrationValue;
        data["concentrationInPrimaryUom"] = this.concentrationInPrimaryUom;
        data["concentrationInSecondaryUom"] = this.concentrationInSecondaryUom;
        return data;
    }
}

export interface IForecastItemActiveIngredientModel {
    id?: number;
    activeIngredient?: string | undefined;
    forecastItemId?: number | undefined;
    forecastItemName?: string | undefined;
    concentrationUomId?: number | undefined;
    concentrationUomName?: string | undefined;
    concentrationValue?: number;
    concentrationInPrimaryUom?: string | undefined;
    concentrationInSecondaryUom?: string | undefined;
}

export class ForecastItemCommentLogModel implements IForecastItemCommentLogModel {
    id?: number;
    forecastItemId?: number;
    comment?: string | undefined;
    userId?: number;
    userName?: string | undefined;
    dateEntered?: Date;
    user?: UserModel;

    constructor(data?: IForecastItemCommentLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forecastItemId = _data["forecastItemId"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.dateEntered = _data["dateEntered"] ? new Date(_data["dateEntered"].toString()) : <any>undefined;
            this.user = _data["user"] ? UserModel.fromJS(_data["user"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemCommentLogModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemCommentLogModel>(data, _mappings, ForecastItemCommentLogModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forecastItemId"] = this.forecastItemId;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["dateEntered"] = this.dateEntered ? this.dateEntered.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IForecastItemCommentLogModel {
    id?: number;
    forecastItemId?: number;
    comment?: string | undefined;
    userId?: number;
    userName?: string | undefined;
    dateEntered?: Date;
    user?: UserModel;
}

export class ForecastItemCommentLogModelResult implements IForecastItemCommentLogModelResult {
    totalCount?: number;
    comments?: ForecastItemCommentLogModel[] | undefined;

    constructor(data?: IForecastItemCommentLogModelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments.push(ForecastItemCommentLogModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemCommentLogModelResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemCommentLogModelResult>(data, _mappings, ForecastItemCommentLogModelResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForecastItemCommentLogModelResult {
    totalCount?: number;
    comments?: ForecastItemCommentLogModel[] | undefined;
}

export class ForecastItemDTO implements IForecastItemDTO {
    totalForecastItems?: number;
    totalPages?: number;
    currentPage?: number;
    forecastItems?: ForecastItemModel[] | undefined;

    constructor(data?: IForecastItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalForecastItems = _data["totalForecastItems"];
            this.totalPages = _data["totalPages"];
            this.currentPage = _data["currentPage"];
            if (Array.isArray(_data["forecastItems"])) {
                this.forecastItems = [] as any;
                for (let item of _data["forecastItems"])
                    this.forecastItems.push(ForecastItemModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemDTO | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemDTO>(data, _mappings, ForecastItemDTO);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalForecastItems"] = this.totalForecastItems;
        data["totalPages"] = this.totalPages;
        data["currentPage"] = this.currentPage;
        if (Array.isArray(this.forecastItems)) {
            data["forecastItems"] = [];
            for (let item of this.forecastItems)
                data["forecastItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForecastItemDTO {
    totalForecastItems?: number;
    totalPages?: number;
    currentPage?: number;
    forecastItems?: ForecastItemModel[] | undefined;
}

export class ForecastItemDelegatedUsers implements IForecastItemDelegatedUsers {
    forecastItemModel?: ForecastItemModel;
    delegaterUsers?: UserModel[] | undefined;

    constructor(data?: IForecastItemDelegatedUsers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.forecastItemModel = _data["forecastItemModel"] ? ForecastItemModel.fromJS(_data["forecastItemModel"], _mappings) : <any>undefined;
            if (Array.isArray(_data["delegaterUsers"])) {
                this.delegaterUsers = [] as any;
                for (let item of _data["delegaterUsers"])
                    this.delegaterUsers.push(UserModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemDelegatedUsers | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemDelegatedUsers>(data, _mappings, ForecastItemDelegatedUsers);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastItemModel"] = this.forecastItemModel ? this.forecastItemModel.toJSON() : <any>undefined;
        if (Array.isArray(this.delegaterUsers)) {
            data["delegaterUsers"] = [];
            for (let item of this.delegaterUsers)
                data["delegaterUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForecastItemDelegatedUsers {
    forecastItemModel?: ForecastItemModel;
    delegaterUsers?: UserModel[] | undefined;
}

export class ForecastItemDestinationModel implements IForecastItemDestinationModel {
    id?: number;
    forecastItemId?: number | undefined;
    forecastItemName?: string | undefined;
    forecasterId?: number;
    forecastClassName?: string | undefined;
    destinationCountryId?: number;
    destinationCountryName?: string | undefined;
    destinationCountryCode?: string | undefined;
    raceLabels?: string | undefined;
    label?: string | undefined;
    quantityUnitOfMeasureId?: number | undefined;
    quantityUomName?: string | undefined;
    packSizeUomId?: number | undefined;
    packSizeUomName?: string | undefined;
    packSizeValue?: number | undefined;
    quantity?: number;
    unUsedQuantity?: number;
    uomDisplayName?: string | undefined;
    manufacturer?: string | undefined;
    oldInventoryOrderStateId?: number | undefined;
    inventoryOrderStateId?: number | undefined;
    inventoryOrderStateName?: string | undefined;
    dateNeeded?: Date;
    dateNeededLatest?: Date | undefined;
    forecastTypeId?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedAt?: Date | undefined;
    forecastType?: ForecastTypeModel;
    forecastTypes?: ForecastTypeModel[] | undefined;
    programNumber?: string | undefined;
    sampleRequesterName?: string | undefined;
    trackingId?: number | undefined;
    submittedByUserName?: string | undefined;
    forecaster?: string | undefined;
    lotNumber?: string | undefined;
    reserved?: boolean;
    relinquishedQuantity?: number | undefined;
    enableReserve?: boolean;
    isReachApproved?: boolean;
    comment?: string | undefined;
    email?: string | undefined;
    materialPlanningGroupId?: number | undefined;
    userId?: number;
    checkedForReservationExpiry?: boolean | undefined;
    hasBeenConsideredForAutoInventory?: boolean;
    qualifiedForAutoInventory?: boolean;
    autoInventoryReasonComment?: string | undefined;
    seasonExpirationDate?: Date | undefined;
    forecastItemDestinationRequester?: ForecastItemDestinationRequesterModel[] | undefined;
    inventoryOrderState?: InventoryStateModel;
    materialPlanningGroup?: MaterialPlanningGroupModel;
    inventoryOrderStateDropdown?: InventoryStateModel[] | undefined;
    inventoryLocationId?: number | undefined;
    inventoryLocation?: SampleInventoryLocationModel;
    forecastItemCommentLogModel?: ForecastItemCommentLogModel[] | undefined;
    readonly inventoryStateOrder?: number;

    constructor(data?: IForecastItemDestinationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forecastItemId = _data["forecastItemId"];
            this.forecastItemName = _data["forecastItemName"];
            this.forecasterId = _data["forecasterId"];
            this.forecastClassName = _data["forecastClassName"];
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCountryName = _data["destinationCountryName"];
            this.destinationCountryCode = _data["destinationCountryCode"];
            this.raceLabels = _data["raceLabels"];
            this.label = _data["label"];
            this.quantityUnitOfMeasureId = _data["quantityUnitOfMeasureId"];
            this.quantityUomName = _data["quantityUomName"];
            this.packSizeUomId = _data["packSizeUomId"];
            this.packSizeUomName = _data["packSizeUomName"];
            this.packSizeValue = _data["packSizeValue"];
            this.quantity = _data["quantity"];
            this.unUsedQuantity = _data["unUsedQuantity"];
            this.uomDisplayName = _data["uomDisplayName"];
            this.manufacturer = _data["manufacturer"];
            this.oldInventoryOrderStateId = _data["oldInventoryOrderStateId"];
            this.inventoryOrderStateId = _data["inventoryOrderStateId"];
            this.inventoryOrderStateName = _data["inventoryOrderStateName"];
            this.dateNeeded = _data["dateNeeded"] ? new Date(_data["dateNeeded"].toString()) : <any>undefined;
            this.dateNeededLatest = _data["dateNeededLatest"] ? new Date(_data["dateNeededLatest"].toString()) : <any>undefined;
            this.forecastTypeId = _data["forecastTypeId"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.forecastType = _data["forecastType"] ? ForecastTypeModel.fromJS(_data["forecastType"], _mappings) : <any>undefined;
            if (Array.isArray(_data["forecastTypes"])) {
                this.forecastTypes = [] as any;
                for (let item of _data["forecastTypes"])
                    this.forecastTypes.push(ForecastTypeModel.fromJS(item, _mappings));
            }
            this.programNumber = _data["programNumber"];
            this.sampleRequesterName = _data["sampleRequesterName"];
            this.trackingId = _data["trackingId"];
            this.submittedByUserName = _data["submittedByUserName"];
            this.forecaster = _data["forecaster"];
            this.lotNumber = _data["lotNumber"];
            this.reserved = _data["reserved"];
            this.relinquishedQuantity = _data["relinquishedQuantity"];
            this.enableReserve = _data["enableReserve"];
            this.isReachApproved = _data["isReachApproved"];
            this.comment = _data["comment"];
            this.email = _data["email"];
            this.materialPlanningGroupId = _data["materialPlanningGroupId"];
            this.userId = _data["userId"];
            this.checkedForReservationExpiry = _data["checkedForReservationExpiry"];
            this.hasBeenConsideredForAutoInventory = _data["hasBeenConsideredForAutoInventory"];
            this.qualifiedForAutoInventory = _data["qualifiedForAutoInventory"];
            this.autoInventoryReasonComment = _data["autoInventoryReasonComment"];
            this.seasonExpirationDate = _data["seasonExpirationDate"] ? new Date(_data["seasonExpirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["forecastItemDestinationRequester"])) {
                this.forecastItemDestinationRequester = [] as any;
                for (let item of _data["forecastItemDestinationRequester"])
                    this.forecastItemDestinationRequester.push(ForecastItemDestinationRequesterModel.fromJS(item, _mappings));
            }
            this.inventoryOrderState = _data["inventoryOrderState"] ? InventoryStateModel.fromJS(_data["inventoryOrderState"], _mappings) : <any>undefined;
            this.materialPlanningGroup = _data["materialPlanningGroup"] ? MaterialPlanningGroupModel.fromJS(_data["materialPlanningGroup"], _mappings) : <any>undefined;
            if (Array.isArray(_data["inventoryOrderStateDropdown"])) {
                this.inventoryOrderStateDropdown = [] as any;
                for (let item of _data["inventoryOrderStateDropdown"])
                    this.inventoryOrderStateDropdown.push(InventoryStateModel.fromJS(item, _mappings));
            }
            this.inventoryLocationId = _data["inventoryLocationId"];
            this.inventoryLocation = _data["inventoryLocation"] ? SampleInventoryLocationModel.fromJS(_data["inventoryLocation"], _mappings) : <any>undefined;
            if (Array.isArray(_data["forecastItemCommentLogModel"])) {
                this.forecastItemCommentLogModel = [] as any;
                for (let item of _data["forecastItemCommentLogModel"])
                    this.forecastItemCommentLogModel.push(ForecastItemCommentLogModel.fromJS(item, _mappings));
            }
            (<any>this).inventoryStateOrder = _data["inventoryStateOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemDestinationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemDestinationModel>(data, _mappings, ForecastItemDestinationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forecastItemId"] = this.forecastItemId;
        data["forecastItemName"] = this.forecastItemName;
        data["forecasterId"] = this.forecasterId;
        data["forecastClassName"] = this.forecastClassName;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCountryName"] = this.destinationCountryName;
        data["destinationCountryCode"] = this.destinationCountryCode;
        data["raceLabels"] = this.raceLabels;
        data["label"] = this.label;
        data["quantityUnitOfMeasureId"] = this.quantityUnitOfMeasureId;
        data["quantityUomName"] = this.quantityUomName;
        data["packSizeUomId"] = this.packSizeUomId;
        data["packSizeUomName"] = this.packSizeUomName;
        data["packSizeValue"] = this.packSizeValue;
        data["quantity"] = this.quantity;
        data["unUsedQuantity"] = this.unUsedQuantity;
        data["uomDisplayName"] = this.uomDisplayName;
        data["manufacturer"] = this.manufacturer;
        data["oldInventoryOrderStateId"] = this.oldInventoryOrderStateId;
        data["inventoryOrderStateId"] = this.inventoryOrderStateId;
        data["inventoryOrderStateName"] = this.inventoryOrderStateName;
        data["dateNeeded"] = this.dateNeeded ? this.dateNeeded.toISOString() : <any>undefined;
        data["dateNeededLatest"] = this.dateNeededLatest ? this.dateNeededLatest.toISOString() : <any>undefined;
        data["forecastTypeId"] = this.forecastTypeId;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["forecastType"] = this.forecastType ? this.forecastType.toJSON() : <any>undefined;
        if (Array.isArray(this.forecastTypes)) {
            data["forecastTypes"] = [];
            for (let item of this.forecastTypes)
                data["forecastTypes"].push(item.toJSON());
        }
        data["programNumber"] = this.programNumber;
        data["sampleRequesterName"] = this.sampleRequesterName;
        data["trackingId"] = this.trackingId;
        data["submittedByUserName"] = this.submittedByUserName;
        data["forecaster"] = this.forecaster;
        data["lotNumber"] = this.lotNumber;
        data["reserved"] = this.reserved;
        data["relinquishedQuantity"] = this.relinquishedQuantity;
        data["enableReserve"] = this.enableReserve;
        data["isReachApproved"] = this.isReachApproved;
        data["comment"] = this.comment;
        data["email"] = this.email;
        data["materialPlanningGroupId"] = this.materialPlanningGroupId;
        data["userId"] = this.userId;
        data["checkedForReservationExpiry"] = this.checkedForReservationExpiry;
        data["hasBeenConsideredForAutoInventory"] = this.hasBeenConsideredForAutoInventory;
        data["qualifiedForAutoInventory"] = this.qualifiedForAutoInventory;
        data["autoInventoryReasonComment"] = this.autoInventoryReasonComment;
        data["seasonExpirationDate"] = this.seasonExpirationDate ? this.seasonExpirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.forecastItemDestinationRequester)) {
            data["forecastItemDestinationRequester"] = [];
            for (let item of this.forecastItemDestinationRequester)
                data["forecastItemDestinationRequester"].push(item.toJSON());
        }
        data["inventoryOrderState"] = this.inventoryOrderState ? this.inventoryOrderState.toJSON() : <any>undefined;
        data["materialPlanningGroup"] = this.materialPlanningGroup ? this.materialPlanningGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.inventoryOrderStateDropdown)) {
            data["inventoryOrderStateDropdown"] = [];
            for (let item of this.inventoryOrderStateDropdown)
                data["inventoryOrderStateDropdown"].push(item.toJSON());
        }
        data["inventoryLocationId"] = this.inventoryLocationId;
        data["inventoryLocation"] = this.inventoryLocation ? this.inventoryLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.forecastItemCommentLogModel)) {
            data["forecastItemCommentLogModel"] = [];
            for (let item of this.forecastItemCommentLogModel)
                data["forecastItemCommentLogModel"].push(item.toJSON());
        }
        data["inventoryStateOrder"] = this.inventoryStateOrder;
        return data;
    }
}

export interface IForecastItemDestinationModel {
    id?: number;
    forecastItemId?: number | undefined;
    forecastItemName?: string | undefined;
    forecasterId?: number;
    forecastClassName?: string | undefined;
    destinationCountryId?: number;
    destinationCountryName?: string | undefined;
    destinationCountryCode?: string | undefined;
    raceLabels?: string | undefined;
    label?: string | undefined;
    quantityUnitOfMeasureId?: number | undefined;
    quantityUomName?: string | undefined;
    packSizeUomId?: number | undefined;
    packSizeUomName?: string | undefined;
    packSizeValue?: number | undefined;
    quantity?: number;
    unUsedQuantity?: number;
    uomDisplayName?: string | undefined;
    manufacturer?: string | undefined;
    oldInventoryOrderStateId?: number | undefined;
    inventoryOrderStateId?: number | undefined;
    inventoryOrderStateName?: string | undefined;
    dateNeeded?: Date;
    dateNeededLatest?: Date | undefined;
    forecastTypeId?: number | undefined;
    modifiedBy?: number | undefined;
    modifiedAt?: Date | undefined;
    forecastType?: ForecastTypeModel;
    forecastTypes?: ForecastTypeModel[] | undefined;
    programNumber?: string | undefined;
    sampleRequesterName?: string | undefined;
    trackingId?: number | undefined;
    submittedByUserName?: string | undefined;
    forecaster?: string | undefined;
    lotNumber?: string | undefined;
    reserved?: boolean;
    relinquishedQuantity?: number | undefined;
    enableReserve?: boolean;
    isReachApproved?: boolean;
    comment?: string | undefined;
    email?: string | undefined;
    materialPlanningGroupId?: number | undefined;
    userId?: number;
    checkedForReservationExpiry?: boolean | undefined;
    hasBeenConsideredForAutoInventory?: boolean;
    qualifiedForAutoInventory?: boolean;
    autoInventoryReasonComment?: string | undefined;
    seasonExpirationDate?: Date | undefined;
    forecastItemDestinationRequester?: ForecastItemDestinationRequesterModel[] | undefined;
    inventoryOrderState?: InventoryStateModel;
    materialPlanningGroup?: MaterialPlanningGroupModel;
    inventoryOrderStateDropdown?: InventoryStateModel[] | undefined;
    inventoryLocationId?: number | undefined;
    inventoryLocation?: SampleInventoryLocationModel;
    forecastItemCommentLogModel?: ForecastItemCommentLogModel[] | undefined;
    inventoryStateOrder?: number;
}

export class ForecastItemDestinationRequesterModel implements IForecastItemDestinationRequesterModel {
    id?: number;
    requesterUserId?: number;
    requestingUserName?: string | undefined;
    forecastItemDestinationId?: number;
    email?: string | undefined;

    constructor(data?: IForecastItemDestinationRequesterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requesterUserId = _data["requesterUserId"];
            this.requestingUserName = _data["requestingUserName"];
            this.forecastItemDestinationId = _data["forecastItemDestinationId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemDestinationRequesterModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemDestinationRequesterModel>(data, _mappings, ForecastItemDestinationRequesterModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requesterUserId"] = this.requesterUserId;
        data["requestingUserName"] = this.requestingUserName;
        data["forecastItemDestinationId"] = this.forecastItemDestinationId;
        data["email"] = this.email;
        return data;
    }
}

export interface IForecastItemDestinationRequesterModel {
    id?: number;
    requesterUserId?: number;
    requestingUserName?: string | undefined;
    forecastItemDestinationId?: number;
    email?: string | undefined;
}

export class ForecastItemLocationModel implements IForecastItemLocationModel {
    forecastItemDestinationId?: number;
    forecastItemId?: number | undefined;
    forecastStatus?: string | undefined;
    forecastType?: string | undefined;
    forecastEndDate?: Date | undefined;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    lotNumber?: string | undefined;
    quantity?: number;
    uom?: string | undefined;
    destinationCountryCode?: string | undefined;
    destinationCountryName?: string | undefined;
    isRegion?: boolean;
    packSizeValue?: number | undefined;
    packSizeUom?: string | undefined;
    inventoryOrderState?: string | undefined;
    inventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    manufacturer?: string | undefined;
    dateNeeded?: Date;
    programNumber?: string | undefined;
    isReachCompliant?: boolean | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    approvedAt?: Date | undefined;
    forecaster?: ForecastItemLocationModelRequesterModel;
    reviewer?: ForecastItemLocationModelRequesterModel;
    delegator?: ForecastItemLocationModelRequesterModel;
    requesters?: ForecastItemLocationModelRequesterModel[] | undefined;

    constructor(data?: IForecastItemLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.forecastItemDestinationId = _data["forecastItemDestinationId"];
            this.forecastItemId = _data["forecastItemId"];
            this.forecastStatus = _data["forecastStatus"];
            this.forecastType = _data["forecastType"];
            this.forecastEndDate = _data["forecastEndDate"] ? new Date(_data["forecastEndDate"].toString()) : <any>undefined;
            this.materialName = _data["materialName"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.synonyms = _data["synonyms"];
            this.lotNumber = _data["lotNumber"];
            this.quantity = _data["quantity"];
            this.uom = _data["uom"];
            this.destinationCountryCode = _data["destinationCountryCode"];
            this.destinationCountryName = _data["destinationCountryName"];
            this.isRegion = _data["isRegion"];
            this.packSizeValue = _data["packSizeValue"];
            this.packSizeUom = _data["packSizeUom"];
            this.inventoryOrderState = _data["inventoryOrderState"];
            this.inventoryLocation = _data["inventoryLocation"];
            this.warehouseId = _data["warehouseId"];
            this.manufacturer = _data["manufacturer"];
            this.dateNeeded = _data["dateNeeded"] ? new Date(_data["dateNeeded"].toString()) : <any>undefined;
            this.programNumber = _data["programNumber"];
            this.isReachCompliant = _data["isReachCompliant"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : <any>undefined;
            this.forecaster = _data["forecaster"] ? ForecastItemLocationModelRequesterModel.fromJS(_data["forecaster"], _mappings) : <any>undefined;
            this.reviewer = _data["reviewer"] ? ForecastItemLocationModelRequesterModel.fromJS(_data["reviewer"], _mappings) : <any>undefined;
            this.delegator = _data["delegator"] ? ForecastItemLocationModelRequesterModel.fromJS(_data["delegator"], _mappings) : <any>undefined;
            if (Array.isArray(_data["requesters"])) {
                this.requesters = [] as any;
                for (let item of _data["requesters"])
                    this.requesters.push(ForecastItemLocationModelRequesterModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemLocationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemLocationModel>(data, _mappings, ForecastItemLocationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastItemDestinationId"] = this.forecastItemDestinationId;
        data["forecastItemId"] = this.forecastItemId;
        data["forecastStatus"] = this.forecastStatus;
        data["forecastType"] = this.forecastType;
        data["forecastEndDate"] = this.forecastEndDate ? this.forecastEndDate.toISOString() : <any>undefined;
        data["materialName"] = this.materialName;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["synonyms"] = this.synonyms;
        data["lotNumber"] = this.lotNumber;
        data["quantity"] = this.quantity;
        data["uom"] = this.uom;
        data["destinationCountryCode"] = this.destinationCountryCode;
        data["destinationCountryName"] = this.destinationCountryName;
        data["isRegion"] = this.isRegion;
        data["packSizeValue"] = this.packSizeValue;
        data["packSizeUom"] = this.packSizeUom;
        data["inventoryOrderState"] = this.inventoryOrderState;
        data["inventoryLocation"] = this.inventoryLocation;
        data["warehouseId"] = this.warehouseId;
        data["manufacturer"] = this.manufacturer;
        data["dateNeeded"] = this.dateNeeded ? this.dateNeeded.toISOString() : <any>undefined;
        data["programNumber"] = this.programNumber;
        data["isReachCompliant"] = this.isReachCompliant;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : <any>undefined;
        data["forecaster"] = this.forecaster ? this.forecaster.toJSON() : <any>undefined;
        data["reviewer"] = this.reviewer ? this.reviewer.toJSON() : <any>undefined;
        data["delegator"] = this.delegator ? this.delegator.toJSON() : <any>undefined;
        if (Array.isArray(this.requesters)) {
            data["requesters"] = [];
            for (let item of this.requesters)
                data["requesters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForecastItemLocationModel {
    forecastItemDestinationId?: number;
    forecastItemId?: number | undefined;
    forecastStatus?: string | undefined;
    forecastType?: string | undefined;
    forecastEndDate?: Date | undefined;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    lotNumber?: string | undefined;
    quantity?: number;
    uom?: string | undefined;
    destinationCountryCode?: string | undefined;
    destinationCountryName?: string | undefined;
    isRegion?: boolean;
    packSizeValue?: number | undefined;
    packSizeUom?: string | undefined;
    inventoryOrderState?: string | undefined;
    inventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    manufacturer?: string | undefined;
    dateNeeded?: Date;
    programNumber?: string | undefined;
    isReachCompliant?: boolean | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    approvedAt?: Date | undefined;
    forecaster?: ForecastItemLocationModelRequesterModel;
    reviewer?: ForecastItemLocationModelRequesterModel;
    delegator?: ForecastItemLocationModelRequesterModel;
    requesters?: ForecastItemLocationModelRequesterModel[] | undefined;
}

export class ForecastItemLocationModelRequesterModel implements IForecastItemLocationModelRequesterModel {
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IForecastItemLocationModelRequesterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemLocationModelRequesterModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemLocationModelRequesterModel>(data, _mappings, ForecastItemLocationModelRequesterModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["email"] = this.email;
        return data;
    }
}

export interface IForecastItemLocationModelRequesterModel {
    userId?: number;
    userName?: string | undefined;
    email?: string | undefined;
}

export class ForecastItemModel implements IForecastItemModel {
    id?: number;
    productName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    materialSearchType?: string | undefined;
    tradeName?: string | undefined;
    commonName?: string | undefined;
    brandName?: string | undefined;
    synonyms?: string | undefined;
    formulationType?: string | undefined;
    lotId?: string | undefined;
    lotNumber?: string | undefined;
    tsnNumber?: string | undefined;
    purity?: string | undefined;
    recertDate?: Date | undefined;
    stage?: string | undefined;
    glpStatus?: string | undefined;
    isGlp?: boolean | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    acceptableAlternativeProduct?: string | undefined;
    altMaterialId?: string | undefined;
    altMaterialRepoName?: string | undefined;
    altMaterialSearchType?: string | undefined;
    altMaterialSynonyms?: string | undefined;
    altMaterialFormulationType?: string | undefined;
    altLotId?: string | undefined;
    altLotNumber?: string | undefined;
    altMaterialTsnNumber?: string | undefined;
    altMaterialIsGlp?: boolean | undefined;
    altMaterialPurity?: string | undefined;
    altMaterialRecertDate?: Date | undefined;
    altMaterialStage?: string | undefined;
    altMaterialGlpStatus?: string | undefined;
    altMaterialApproverName?: string | undefined;
    altMaterialApproverEmail?: string | undefined;
    isDas?: boolean;
    isReachCompliant?: boolean | undefined;
    formulationNumber?: string | undefined;
    formulationTypeId?: number | undefined;
    formulationTypeName?: string | undefined;
    quantityUnitOfMeasureId?: number | undefined;
    quantityUnitOfMeasureName?: string | undefined;
    forecastTypeId?: number | undefined;
    forecastTypeName?: string | undefined;
    comments?: string | undefined;
    forecastingSeasonId?: number | undefined;
    forecastingSeasonName?: string | undefined;
    forecastingUserId?: number | undefined;
    forecastingUserName?: string | undefined;
    forecastingUserEmail?: string | undefined;
    forecastingLastName?: string | undefined;
    reviewerUserId?: number | undefined;
    reviewerUserName?: string | undefined;
    reviewerLastName?: string | undefined;
    delegatorUserId?: number | undefined;
    delegatorUserName?: string | undefined;
    delegatorLastName?: string | undefined;
    trialInfo?: string | undefined;
    servingAlternateItem?: boolean;
    stateId?: number | undefined;
    stateName?: string | undefined;
    createdAt?: Date;
    lastUpdatedAt?: Date | undefined;
    delegatedOn?: Date | undefined;
    dateSubmitted?: Date | undefined;
    updatedBy?: number | undefined;
    updateByName?: string | undefined;
    isModifiable?: boolean;
    isDeletable?: boolean;
    materialPlannerName?: string | undefined;
    materialPlannerEmail?: string | undefined;
    bypassReservation?: boolean;
    isApproved?: boolean | undefined;
    approvedAt?: Date | undefined;
    inventoryLocation?: SampleInventoryLocationModel;
    forecastSeason?: ForecastingSeasonModel;
    forecastItemActiveIngredient?: ForecastItemActiveIngredientModel[] | undefined;
    altForecastItemActiveIngredient?: AltForecastItemActiveIngredientModel[] | undefined;
    forecastItemDestination?: ForecastItemDestinationModel[] | undefined;
    forecastItemCommentLogModel?: ForecastItemCommentLogModel[] | undefined;

    constructor(data?: IForecastItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.materialSearchType = _data["materialSearchType"];
            this.tradeName = _data["tradeName"];
            this.commonName = _data["commonName"];
            this.brandName = _data["brandName"];
            this.synonyms = _data["synonyms"];
            this.formulationType = _data["formulationType"];
            this.lotId = _data["lotId"];
            this.lotNumber = _data["lotNumber"];
            this.tsnNumber = _data["tsnNumber"];
            this.purity = _data["purity"];
            this.recertDate = _data["recertDate"] ? new Date(_data["recertDate"].toString()) : <any>undefined;
            this.stage = _data["stage"];
            this.glpStatus = _data["glpStatus"];
            this.isGlp = _data["isGlp"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.acceptableAlternativeProduct = _data["acceptableAlternativeProduct"];
            this.altMaterialId = _data["altMaterialId"];
            this.altMaterialRepoName = _data["altMaterialRepoName"];
            this.altMaterialSearchType = _data["altMaterialSearchType"];
            this.altMaterialSynonyms = _data["altMaterialSynonyms"];
            this.altMaterialFormulationType = _data["altMaterialFormulationType"];
            this.altLotId = _data["altLotId"];
            this.altLotNumber = _data["altLotNumber"];
            this.altMaterialTsnNumber = _data["altMaterialTsnNumber"];
            this.altMaterialIsGlp = _data["altMaterialIsGlp"];
            this.altMaterialPurity = _data["altMaterialPurity"];
            this.altMaterialRecertDate = _data["altMaterialRecertDate"] ? new Date(_data["altMaterialRecertDate"].toString()) : <any>undefined;
            this.altMaterialStage = _data["altMaterialStage"];
            this.altMaterialGlpStatus = _data["altMaterialGlpStatus"];
            this.altMaterialApproverName = _data["altMaterialApproverName"];
            this.altMaterialApproverEmail = _data["altMaterialApproverEmail"];
            this.isDas = _data["isDas"];
            this.isReachCompliant = _data["isReachCompliant"];
            this.formulationNumber = _data["formulationNumber"];
            this.formulationTypeId = _data["formulationTypeId"];
            this.formulationTypeName = _data["formulationTypeName"];
            this.quantityUnitOfMeasureId = _data["quantityUnitOfMeasureId"];
            this.quantityUnitOfMeasureName = _data["quantityUnitOfMeasureName"];
            this.forecastTypeId = _data["forecastTypeId"];
            this.forecastTypeName = _data["forecastTypeName"];
            this.comments = _data["comments"];
            this.forecastingSeasonId = _data["forecastingSeasonId"];
            this.forecastingSeasonName = _data["forecastingSeasonName"];
            this.forecastingUserId = _data["forecastingUserId"];
            this.forecastingUserName = _data["forecastingUserName"];
            this.forecastingUserEmail = _data["forecastingUserEmail"];
            this.forecastingLastName = _data["forecastingLastName"];
            this.reviewerUserId = _data["reviewerUserId"];
            this.reviewerUserName = _data["reviewerUserName"];
            this.reviewerLastName = _data["reviewerLastName"];
            this.delegatorUserId = _data["delegatorUserId"];
            this.delegatorUserName = _data["delegatorUserName"];
            this.delegatorLastName = _data["delegatorLastName"];
            this.trialInfo = _data["trialInfo"];
            this.servingAlternateItem = _data["servingAlternateItem"];
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.delegatedOn = _data["delegatedOn"] ? new Date(_data["delegatedOn"].toString()) : <any>undefined;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updateByName = _data["updateByName"];
            this.isModifiable = _data["isModifiable"];
            this.isDeletable = _data["isDeletable"];
            this.materialPlannerName = _data["materialPlannerName"];
            this.materialPlannerEmail = _data["materialPlannerEmail"];
            this.bypassReservation = _data["bypassReservation"];
            this.isApproved = _data["isApproved"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : <any>undefined;
            this.inventoryLocation = _data["inventoryLocation"] ? SampleInventoryLocationModel.fromJS(_data["inventoryLocation"], _mappings) : <any>undefined;
            this.forecastSeason = _data["forecastSeason"] ? ForecastingSeasonModel.fromJS(_data["forecastSeason"], _mappings) : <any>undefined;
            if (Array.isArray(_data["forecastItemActiveIngredient"])) {
                this.forecastItemActiveIngredient = [] as any;
                for (let item of _data["forecastItemActiveIngredient"])
                    this.forecastItemActiveIngredient.push(ForecastItemActiveIngredientModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["altForecastItemActiveIngredient"])) {
                this.altForecastItemActiveIngredient = [] as any;
                for (let item of _data["altForecastItemActiveIngredient"])
                    this.altForecastItemActiveIngredient.push(AltForecastItemActiveIngredientModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["forecastItemDestination"])) {
                this.forecastItemDestination = [] as any;
                for (let item of _data["forecastItemDestination"])
                    this.forecastItemDestination.push(ForecastItemDestinationModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["forecastItemCommentLogModel"])) {
                this.forecastItemCommentLogModel = [] as any;
                for (let item of _data["forecastItemCommentLogModel"])
                    this.forecastItemCommentLogModel.push(ForecastItemCommentLogModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastItemModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastItemModel>(data, _mappings, ForecastItemModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["materialSearchType"] = this.materialSearchType;
        data["tradeName"] = this.tradeName;
        data["commonName"] = this.commonName;
        data["brandName"] = this.brandName;
        data["synonyms"] = this.synonyms;
        data["formulationType"] = this.formulationType;
        data["lotId"] = this.lotId;
        data["lotNumber"] = this.lotNumber;
        data["tsnNumber"] = this.tsnNumber;
        data["purity"] = this.purity;
        data["recertDate"] = this.recertDate ? this.recertDate.toISOString() : <any>undefined;
        data["stage"] = this.stage;
        data["glpStatus"] = this.glpStatus;
        data["isGlp"] = this.isGlp;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["acceptableAlternativeProduct"] = this.acceptableAlternativeProduct;
        data["altMaterialId"] = this.altMaterialId;
        data["altMaterialRepoName"] = this.altMaterialRepoName;
        data["altMaterialSearchType"] = this.altMaterialSearchType;
        data["altMaterialSynonyms"] = this.altMaterialSynonyms;
        data["altMaterialFormulationType"] = this.altMaterialFormulationType;
        data["altLotId"] = this.altLotId;
        data["altLotNumber"] = this.altLotNumber;
        data["altMaterialTsnNumber"] = this.altMaterialTsnNumber;
        data["altMaterialIsGlp"] = this.altMaterialIsGlp;
        data["altMaterialPurity"] = this.altMaterialPurity;
        data["altMaterialRecertDate"] = this.altMaterialRecertDate ? this.altMaterialRecertDate.toISOString() : <any>undefined;
        data["altMaterialStage"] = this.altMaterialStage;
        data["altMaterialGlpStatus"] = this.altMaterialGlpStatus;
        data["altMaterialApproverName"] = this.altMaterialApproverName;
        data["altMaterialApproverEmail"] = this.altMaterialApproverEmail;
        data["isDas"] = this.isDas;
        data["isReachCompliant"] = this.isReachCompliant;
        data["formulationNumber"] = this.formulationNumber;
        data["formulationTypeId"] = this.formulationTypeId;
        data["formulationTypeName"] = this.formulationTypeName;
        data["quantityUnitOfMeasureId"] = this.quantityUnitOfMeasureId;
        data["quantityUnitOfMeasureName"] = this.quantityUnitOfMeasureName;
        data["forecastTypeId"] = this.forecastTypeId;
        data["forecastTypeName"] = this.forecastTypeName;
        data["comments"] = this.comments;
        data["forecastingSeasonId"] = this.forecastingSeasonId;
        data["forecastingSeasonName"] = this.forecastingSeasonName;
        data["forecastingUserId"] = this.forecastingUserId;
        data["forecastingUserName"] = this.forecastingUserName;
        data["forecastingUserEmail"] = this.forecastingUserEmail;
        data["forecastingLastName"] = this.forecastingLastName;
        data["reviewerUserId"] = this.reviewerUserId;
        data["reviewerUserName"] = this.reviewerUserName;
        data["reviewerLastName"] = this.reviewerLastName;
        data["delegatorUserId"] = this.delegatorUserId;
        data["delegatorUserName"] = this.delegatorUserName;
        data["delegatorLastName"] = this.delegatorLastName;
        data["trialInfo"] = this.trialInfo;
        data["servingAlternateItem"] = this.servingAlternateItem;
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["delegatedOn"] = this.delegatedOn ? this.delegatedOn.toISOString() : <any>undefined;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updateByName"] = this.updateByName;
        data["isModifiable"] = this.isModifiable;
        data["isDeletable"] = this.isDeletable;
        data["materialPlannerName"] = this.materialPlannerName;
        data["materialPlannerEmail"] = this.materialPlannerEmail;
        data["bypassReservation"] = this.bypassReservation;
        data["isApproved"] = this.isApproved;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : <any>undefined;
        data["inventoryLocation"] = this.inventoryLocation ? this.inventoryLocation.toJSON() : <any>undefined;
        data["forecastSeason"] = this.forecastSeason ? this.forecastSeason.toJSON() : <any>undefined;
        if (Array.isArray(this.forecastItemActiveIngredient)) {
            data["forecastItemActiveIngredient"] = [];
            for (let item of this.forecastItemActiveIngredient)
                data["forecastItemActiveIngredient"].push(item.toJSON());
        }
        if (Array.isArray(this.altForecastItemActiveIngredient)) {
            data["altForecastItemActiveIngredient"] = [];
            for (let item of this.altForecastItemActiveIngredient)
                data["altForecastItemActiveIngredient"].push(item.toJSON());
        }
        if (Array.isArray(this.forecastItemDestination)) {
            data["forecastItemDestination"] = [];
            for (let item of this.forecastItemDestination)
                data["forecastItemDestination"].push(item.toJSON());
        }
        if (Array.isArray(this.forecastItemCommentLogModel)) {
            data["forecastItemCommentLogModel"] = [];
            for (let item of this.forecastItemCommentLogModel)
                data["forecastItemCommentLogModel"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForecastItemModel {
    id?: number;
    productName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    materialSearchType?: string | undefined;
    tradeName?: string | undefined;
    commonName?: string | undefined;
    brandName?: string | undefined;
    synonyms?: string | undefined;
    formulationType?: string | undefined;
    lotId?: string | undefined;
    lotNumber?: string | undefined;
    tsnNumber?: string | undefined;
    purity?: string | undefined;
    recertDate?: Date | undefined;
    stage?: string | undefined;
    glpStatus?: string | undefined;
    isGlp?: boolean | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    acceptableAlternativeProduct?: string | undefined;
    altMaterialId?: string | undefined;
    altMaterialRepoName?: string | undefined;
    altMaterialSearchType?: string | undefined;
    altMaterialSynonyms?: string | undefined;
    altMaterialFormulationType?: string | undefined;
    altLotId?: string | undefined;
    altLotNumber?: string | undefined;
    altMaterialTsnNumber?: string | undefined;
    altMaterialIsGlp?: boolean | undefined;
    altMaterialPurity?: string | undefined;
    altMaterialRecertDate?: Date | undefined;
    altMaterialStage?: string | undefined;
    altMaterialGlpStatus?: string | undefined;
    altMaterialApproverName?: string | undefined;
    altMaterialApproverEmail?: string | undefined;
    isDas?: boolean;
    isReachCompliant?: boolean | undefined;
    formulationNumber?: string | undefined;
    formulationTypeId?: number | undefined;
    formulationTypeName?: string | undefined;
    quantityUnitOfMeasureId?: number | undefined;
    quantityUnitOfMeasureName?: string | undefined;
    forecastTypeId?: number | undefined;
    forecastTypeName?: string | undefined;
    comments?: string | undefined;
    forecastingSeasonId?: number | undefined;
    forecastingSeasonName?: string | undefined;
    forecastingUserId?: number | undefined;
    forecastingUserName?: string | undefined;
    forecastingUserEmail?: string | undefined;
    forecastingLastName?: string | undefined;
    reviewerUserId?: number | undefined;
    reviewerUserName?: string | undefined;
    reviewerLastName?: string | undefined;
    delegatorUserId?: number | undefined;
    delegatorUserName?: string | undefined;
    delegatorLastName?: string | undefined;
    trialInfo?: string | undefined;
    servingAlternateItem?: boolean;
    stateId?: number | undefined;
    stateName?: string | undefined;
    createdAt?: Date;
    lastUpdatedAt?: Date | undefined;
    delegatedOn?: Date | undefined;
    dateSubmitted?: Date | undefined;
    updatedBy?: number | undefined;
    updateByName?: string | undefined;
    isModifiable?: boolean;
    isDeletable?: boolean;
    materialPlannerName?: string | undefined;
    materialPlannerEmail?: string | undefined;
    bypassReservation?: boolean;
    isApproved?: boolean | undefined;
    approvedAt?: Date | undefined;
    inventoryLocation?: SampleInventoryLocationModel;
    forecastSeason?: ForecastingSeasonModel;
    forecastItemActiveIngredient?: ForecastItemActiveIngredientModel[] | undefined;
    altForecastItemActiveIngredient?: AltForecastItemActiveIngredientModel[] | undefined;
    forecastItemDestination?: ForecastItemDestinationModel[] | undefined;
    forecastItemCommentLogModel?: ForecastItemCommentLogModel[] | undefined;
}

export class ForecastMaterialApprovalModel implements IForecastMaterialApprovalModel {
    forecastItemId?: number;
    forecaster?: string | undefined;
    productName?: string | undefined;
    lotNumber?: string | undefined;
    quantity?: number;
    quantityWithUomBreakup?: string | undefined;
    uom?: string | undefined;
    forecasterEmail?: string | undefined;
    approverEmail?: string | undefined;
    earliestDateNeeded?: string | undefined;
    requesters?: string[] | undefined;
    destinations?: string[] | undefined;

    constructor(data?: IForecastMaterialApprovalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.forecastItemId = _data["forecastItemId"];
            this.forecaster = _data["forecaster"];
            this.productName = _data["productName"];
            this.lotNumber = _data["lotNumber"];
            this.quantity = _data["quantity"];
            this.quantityWithUomBreakup = _data["quantityWithUomBreakup"];
            this.uom = _data["uom"];
            this.forecasterEmail = _data["forecasterEmail"];
            this.approverEmail = _data["approverEmail"];
            this.earliestDateNeeded = _data["earliestDateNeeded"];
            if (Array.isArray(_data["requesters"])) {
                this.requesters = [] as any;
                for (let item of _data["requesters"])
                    this.requesters.push(item);
            }
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastMaterialApprovalModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastMaterialApprovalModel>(data, _mappings, ForecastMaterialApprovalModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastItemId"] = this.forecastItemId;
        data["forecaster"] = this.forecaster;
        data["productName"] = this.productName;
        data["lotNumber"] = this.lotNumber;
        data["quantity"] = this.quantity;
        data["quantityWithUomBreakup"] = this.quantityWithUomBreakup;
        data["uom"] = this.uom;
        data["forecasterEmail"] = this.forecasterEmail;
        data["approverEmail"] = this.approverEmail;
        data["earliestDateNeeded"] = this.earliestDateNeeded;
        if (Array.isArray(this.requesters)) {
            data["requesters"] = [];
            for (let item of this.requesters)
                data["requesters"].push(item);
        }
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item);
        }
        return data;
    }
}

export interface IForecastMaterialApprovalModel {
    forecastItemId?: number;
    forecaster?: string | undefined;
    productName?: string | undefined;
    lotNumber?: string | undefined;
    quantity?: number;
    quantityWithUomBreakup?: string | undefined;
    uom?: string | undefined;
    forecasterEmail?: string | undefined;
    approverEmail?: string | undefined;
    earliestDateNeeded?: string | undefined;
    requesters?: string[] | undefined;
    destinations?: string[] | undefined;
}

export class ForecastMaterialApprovalModelResult implements IForecastMaterialApprovalModelResult {
    totalCount?: number;
    approvals?: ForecastMaterialApprovalModel[] | undefined;

    constructor(data?: IForecastMaterialApprovalModelResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals.push(ForecastMaterialApprovalModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastMaterialApprovalModelResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastMaterialApprovalModelResult>(data, _mappings, ForecastMaterialApprovalModelResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForecastMaterialApprovalModelResult {
    totalCount?: number;
    approvals?: ForecastMaterialApprovalModel[] | undefined;
}

export class ForecastStateModel implements IForecastStateModel {
    id?: number;
    stateName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IForecastStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateName = _data["stateName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastStateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastStateModel>(data, _mappings, ForecastStateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateName"] = this.stateName;
        data["description"] = this.description;
        return data;
    }
}

export interface IForecastStateModel {
    id?: number;
    stateName?: string | undefined;
    description?: string | undefined;
}

export class ForecastTypeModel implements IForecastTypeModel {
    id?: number;
    forecastType1?: string | undefined;

    constructor(data?: IForecastTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forecastType1 = _data["forecastType1"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastTypeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastTypeModel>(data, _mappings, ForecastTypeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forecastType1"] = this.forecastType1;
        return data;
    }
}

export interface IForecastTypeModel {
    id?: number;
    forecastType1?: string | undefined;
}

export class ForecastingSeasonModel implements IForecastingSeasonModel {
    id?: number;
    name?: string | undefined;
    startDate?: Date | undefined;
    dueDate?: Date | undefined;
    reservationExpiryDate?: Date | undefined;

    constructor(data?: IForecastingSeasonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.reservationExpiryDate = _data["reservationExpiryDate"] ? new Date(_data["reservationExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastingSeasonModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastingSeasonModel>(data, _mappings, ForecastingSeasonModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["reservationExpiryDate"] = this.reservationExpiryDate ? this.reservationExpiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IForecastingSeasonModel {
    id?: number;
    name?: string | undefined;
    startDate?: Date | undefined;
    dueDate?: Date | undefined;
    reservationExpiryDate?: Date | undefined;
}

export class FormulationTypeServiceModel implements IFormulationTypeServiceModel {
    id?: number | undefined;
    formulationTypeCode?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;

    constructor(data?: IFormulationTypeServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formulationTypeCode = _data["formulationTypeCode"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any, _mappings?: any): FormulationTypeServiceModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FormulationTypeServiceModel>(data, _mappings, FormulationTypeServiceModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formulationTypeCode"] = this.formulationTypeCode;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IFormulationTypeServiceModel {
    id?: number | undefined;
    formulationTypeCode?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean;
}

export class InventoryStateModel implements IInventoryStateModel {
    id?: number;
    stateName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IInventoryStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateName = _data["stateName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any, _mappings?: any): InventoryStateModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InventoryStateModel>(data, _mappings, InventoryStateModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateName"] = this.stateName;
        data["description"] = this.description;
        return data;
    }
}

export interface IInventoryStateModel {
    id?: number;
    stateName?: string | undefined;
    description?: string | undefined;
}

export class JobFunction implements IJobFunction {
    id?: number;
    functionName?: string | undefined;

    constructor(data?: IJobFunction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.functionName = _data["functionName"];
        }
    }

    static fromJS(data: any, _mappings?: any): JobFunction | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<JobFunction>(data, _mappings, JobFunction);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["functionName"] = this.functionName;
        return data;
    }
}

export interface IJobFunction {
    id?: number;
    functionName?: string | undefined;
}

export class LeaderDelegatesModel implements ILeaderDelegatesModel {
    leader?: UserModel;
    delegates?: UserModel[] | undefined;

    constructor(data?: ILeaderDelegatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.leader = _data["leader"] ? UserModel.fromJS(_data["leader"], _mappings) : <any>undefined;
            if (Array.isArray(_data["delegates"])) {
                this.delegates = [] as any;
                for (let item of _data["delegates"])
                    this.delegates.push(UserModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): LeaderDelegatesModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<LeaderDelegatesModel>(data, _mappings, LeaderDelegatesModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leader"] = this.leader ? this.leader.toJSON() : <any>undefined;
        if (Array.isArray(this.delegates)) {
            data["delegates"] = [];
            for (let item of this.delegates)
                data["delegates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILeaderDelegatesModel {
    leader?: UserModel;
    delegates?: UserModel[] | undefined;
}

export class MaterialCompositionDto implements IMaterialCompositionDto {
    id?: number;
    materialName?: string | undefined;
    quantityForecasted?: number | undefined;
    quantityAvailable?: number;
    farmEntryDate?: Date;
    programNumber?: string | undefined;
    forecastItemId?: number | undefined;
    procurementStatus?: string | undefined;
    reachApproved?: boolean;
    materialPlanner?: string | undefined;
    materialPlannerId?: number | undefined;
    procurementComments?: string | undefined;
    materialPlannerEmail?: string | undefined;
    cpssNumber?: string | undefined;
    cpssDate?: Date | undefined;
    isCancelled?: boolean | undefined;

    constructor(data?: IMaterialCompositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialName = _data["materialName"];
            this.quantityForecasted = _data["quantityForecasted"];
            this.quantityAvailable = _data["quantityAvailable"];
            this.farmEntryDate = _data["farmEntryDate"] ? new Date(_data["farmEntryDate"].toString()) : <any>undefined;
            this.programNumber = _data["programNumber"];
            this.forecastItemId = _data["forecastItemId"];
            this.procurementStatus = _data["procurementStatus"];
            this.reachApproved = _data["reachApproved"];
            this.materialPlanner = _data["materialPlanner"];
            this.materialPlannerId = _data["materialPlannerId"];
            this.procurementComments = _data["procurementComments"];
            this.materialPlannerEmail = _data["materialPlannerEmail"];
            this.cpssNumber = _data["cpssNumber"];
            this.cpssDate = _data["cpssDate"] ? new Date(_data["cpssDate"].toString()) : <any>undefined;
            this.isCancelled = _data["isCancelled"];
        }
    }

    static fromJS(data: any, _mappings?: any): MaterialCompositionDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaterialCompositionDto>(data, _mappings, MaterialCompositionDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["quantityForecasted"] = this.quantityForecasted;
        data["quantityAvailable"] = this.quantityAvailable;
        data["farmEntryDate"] = this.farmEntryDate ? this.farmEntryDate.toISOString() : <any>undefined;
        data["programNumber"] = this.programNumber;
        data["forecastItemId"] = this.forecastItemId;
        data["procurementStatus"] = this.procurementStatus;
        data["reachApproved"] = this.reachApproved;
        data["materialPlanner"] = this.materialPlanner;
        data["materialPlannerId"] = this.materialPlannerId;
        data["procurementComments"] = this.procurementComments;
        data["materialPlannerEmail"] = this.materialPlannerEmail;
        data["cpssNumber"] = this.cpssNumber;
        data["cpssDate"] = this.cpssDate ? this.cpssDate.toISOString() : <any>undefined;
        data["isCancelled"] = this.isCancelled;
        return data;
    }
}

export interface IMaterialCompositionDto {
    id?: number;
    materialName?: string | undefined;
    quantityForecasted?: number | undefined;
    quantityAvailable?: number;
    farmEntryDate?: Date;
    programNumber?: string | undefined;
    forecastItemId?: number | undefined;
    procurementStatus?: string | undefined;
    reachApproved?: boolean;
    materialPlanner?: string | undefined;
    materialPlannerId?: number | undefined;
    procurementComments?: string | undefined;
    materialPlannerEmail?: string | undefined;
    cpssNumber?: string | undefined;
    cpssDate?: Date | undefined;
    isCancelled?: boolean | undefined;
}

export class MaterialPlannerRequestModel implements IMaterialPlannerRequestModel {
    filterId?: number;
    country?: string | undefined;
    materialName?: string | undefined;
    forecastNumber?: number | undefined;
    materialPlannerUserId?: number | undefined;
    forecasterId?: number | undefined;
    inventoryState?: InventoryStateModel[] | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    toDate?: string | undefined;
    fromDate?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IMaterialPlannerRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            this.country = _data["country"];
            this.materialName = _data["materialName"];
            this.forecastNumber = _data["forecastNumber"];
            this.materialPlannerUserId = _data["materialPlannerUserId"];
            this.forecasterId = _data["forecasterId"];
            if (Array.isArray(_data["inventoryState"])) {
                this.inventoryState = [] as any;
                for (let item of _data["inventoryState"])
                    this.inventoryState.push(InventoryStateModel.fromJS(item, _mappings));
            }
            this.sortOrder = _data["sortOrder"];
            this.isASC = _data["isASC"];
            this.toDate = _data["toDate"];
            this.fromDate = _data["fromDate"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any, _mappings?: any): MaterialPlannerRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaterialPlannerRequestModel>(data, _mappings, MaterialPlannerRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        data["country"] = this.country;
        data["materialName"] = this.materialName;
        data["forecastNumber"] = this.forecastNumber;
        data["materialPlannerUserId"] = this.materialPlannerUserId;
        data["forecasterId"] = this.forecasterId;
        if (Array.isArray(this.inventoryState)) {
            data["inventoryState"] = [];
            for (let item of this.inventoryState)
                data["inventoryState"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        data["isASC"] = this.isASC;
        data["toDate"] = this.toDate;
        data["fromDate"] = this.fromDate;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IMaterialPlannerRequestModel {
    filterId?: number;
    country?: string | undefined;
    materialName?: string | undefined;
    forecastNumber?: number | undefined;
    materialPlannerUserId?: number | undefined;
    forecasterId?: number | undefined;
    inventoryState?: InventoryStateModel[] | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    toDate?: string | undefined;
    fromDate?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class MaterialPlanningGroupModel implements IMaterialPlanningGroupModel {
    id?: number;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    formulationType?: string | undefined;
    materialPlannerId?: number | undefined;
    updatedBy?: number | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IMaterialPlanningGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialName = _data["materialName"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.formulationType = _data["formulationType"];
            this.materialPlannerId = _data["materialPlannerId"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): MaterialPlanningGroupModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaterialPlanningGroupModel>(data, _mappings, MaterialPlanningGroupModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialName"] = this.materialName;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["formulationType"] = this.formulationType;
        data["materialPlannerId"] = this.materialPlannerId;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMaterialPlanningGroupModel {
    id?: number;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    formulationType?: string | undefined;
    materialPlannerId?: number | undefined;
    updatedBy?: number | undefined;
    updatedAt?: Date | undefined;
}

export class MaterialPurposeModel implements IMaterialPurposeModel {
    id?: number;
    materialPurpose1?: string | undefined;

    constructor(data?: IMaterialPurposeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.materialPurpose1 = _data["materialPurpose1"];
        }
    }

    static fromJS(data: any, _mappings?: any): MaterialPurposeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaterialPurposeModel>(data, _mappings, MaterialPurposeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["materialPurpose1"] = this.materialPurpose1;
        return data;
    }
}

export interface IMaterialPurposeModel {
    id?: number;
    materialPurpose1?: string | undefined;
}

export class OrderItemActiveIngredientModel implements IOrderItemActiveIngredientModel {
    id?: number;
    orderItemId?: number;
    activeIngredient?: string | undefined;
    concentrationUomId?: number | undefined;
    concentrationValue?: number | undefined;
    concentrationInPrimaryUom?: string | undefined;
    concentrationInSecondaryUom?: string | undefined;
    uomDisplayName?: string | undefined;

    constructor(data?: IOrderItemActiveIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderItemId = _data["orderItemId"];
            this.activeIngredient = _data["activeIngredient"];
            this.concentrationUomId = _data["concentrationUomId"];
            this.concentrationValue = _data["concentrationValue"];
            this.concentrationInPrimaryUom = _data["concentrationInPrimaryUom"];
            this.concentrationInSecondaryUom = _data["concentrationInSecondaryUom"];
            this.uomDisplayName = _data["uomDisplayName"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemActiveIngredientModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemActiveIngredientModel>(data, _mappings, OrderItemActiveIngredientModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderItemId"] = this.orderItemId;
        data["activeIngredient"] = this.activeIngredient;
        data["concentrationUomId"] = this.concentrationUomId;
        data["concentrationValue"] = this.concentrationValue;
        data["concentrationInPrimaryUom"] = this.concentrationInPrimaryUom;
        data["concentrationInSecondaryUom"] = this.concentrationInSecondaryUom;
        data["uomDisplayName"] = this.uomDisplayName;
        return data;
    }
}

export interface IOrderItemActiveIngredientModel {
    id?: number;
    orderItemId?: number;
    activeIngredient?: string | undefined;
    concentrationUomId?: number | undefined;
    concentrationValue?: number | undefined;
    concentrationInPrimaryUom?: string | undefined;
    concentrationInSecondaryUom?: string | undefined;
    uomDisplayName?: string | undefined;
}

export class OrderItemCommentModel implements IOrderItemCommentModel {
    id?: number;
    comment?: string | undefined;
    enteredByUserId?: number;
    enteredByUserName?: string | undefined;
    enteredAt?: Date;
    orderItemId?: number;

    constructor(data?: IOrderItemCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.enteredByUserId = _data["enteredByUserId"];
            this.enteredByUserName = _data["enteredByUserName"];
            this.enteredAt = _data["enteredAt"] ? new Date(_data["enteredAt"].toString()) : <any>undefined;
            this.orderItemId = _data["orderItemId"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemCommentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemCommentModel>(data, _mappings, OrderItemCommentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["enteredByUserId"] = this.enteredByUserId;
        data["enteredByUserName"] = this.enteredByUserName;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        data["orderItemId"] = this.orderItemId;
        return data;
    }
}

export interface IOrderItemCommentModel {
    id?: number;
    comment?: string | undefined;
    enteredByUserId?: number;
    enteredByUserName?: string | undefined;
    enteredAt?: Date;
    orderItemId?: number;
}

export class OrderItemDestinationModel implements IOrderItemDestinationModel {
    id?: number;
    orderItemId?: number;
    destinationCountryId?: number | undefined;
    countryName?: string | undefined;
    countryCode?: string | undefined;
    isRegion?: boolean;
    orderItemForecastDestination?: OrderItemForecastDestinationModel[] | undefined;

    constructor(data?: IOrderItemDestinationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderItemId = _data["orderItemId"];
            this.destinationCountryId = _data["destinationCountryId"];
            this.countryName = _data["countryName"];
            this.countryCode = _data["countryCode"];
            this.isRegion = _data["isRegion"];
            if (Array.isArray(_data["orderItemForecastDestination"])) {
                this.orderItemForecastDestination = [] as any;
                for (let item of _data["orderItemForecastDestination"])
                    this.orderItemForecastDestination.push(OrderItemForecastDestinationModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemDestinationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemDestinationModel>(data, _mappings, OrderItemDestinationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderItemId"] = this.orderItemId;
        data["destinationCountryId"] = this.destinationCountryId;
        data["countryName"] = this.countryName;
        data["countryCode"] = this.countryCode;
        data["isRegion"] = this.isRegion;
        if (Array.isArray(this.orderItemForecastDestination)) {
            data["orderItemForecastDestination"] = [];
            for (let item of this.orderItemForecastDestination)
                data["orderItemForecastDestination"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderItemDestinationModel {
    id?: number;
    orderItemId?: number;
    destinationCountryId?: number | undefined;
    countryName?: string | undefined;
    countryCode?: string | undefined;
    isRegion?: boolean;
    orderItemForecastDestination?: OrderItemForecastDestinationModel[] | undefined;
}

export class OrderItemForecastDestinationModel implements IOrderItemForecastDestinationModel {
    id?: number;
    orderItemDestinationId?: number;
    forecastItemDestinationId?: number | undefined;
    country?: string | undefined;
    forecastItemId?: number | undefined;
    quantity?: number;
    unUsedQuantity?: number;
    quantityUomId?: number;
    uomDisplay?: string | undefined;
    isFulfilled?: boolean;
    isNonForecast?: boolean;
    requesterUserId?: number | undefined;
    requesterUser?: UserModel;
    requesterName?: string | undefined;
    materialPlannerName?: string | undefined;
    rdsimsRequestNumber?: string | undefined;
    requestNumber?: string | undefined;
    alternativeProduct?: string | undefined;
    materialPlanningGroupId?: number | undefined;
    dateNeeded?: Date | undefined;
    approvedAlternative?: string | undefined;
    requestSubmissionDate?: Date | undefined;
    orderTypeId?: number | undefined;
    materialPurposeId?: number | undefined;
    orderStatusId?: number;
    orderType?: OrderTypeModel;
    forecastItem?: ForecastItemModel;
    forecastItemDestination?: ForecastItemDestinationModel;
    materialPurpose?: MaterialPurposeModel;
    orderStatus?: OrderStatusModel;
    lotNumber?: string | undefined;
    inventoryLocation?: SampleInventoryLocationModel;

    constructor(data?: IOrderItemForecastDestinationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderItemDestinationId = _data["orderItemDestinationId"];
            this.forecastItemDestinationId = _data["forecastItemDestinationId"];
            this.country = _data["country"];
            this.forecastItemId = _data["forecastItemId"];
            this.quantity = _data["quantity"];
            this.unUsedQuantity = _data["unUsedQuantity"];
            this.quantityUomId = _data["quantityUomId"];
            this.uomDisplay = _data["uomDisplay"];
            this.isFulfilled = _data["isFulfilled"];
            this.isNonForecast = _data["isNonForecast"];
            this.requesterUserId = _data["requesterUserId"];
            this.requesterUser = _data["requesterUser"] ? UserModel.fromJS(_data["requesterUser"], _mappings) : <any>undefined;
            this.requesterName = _data["requesterName"];
            this.materialPlannerName = _data["materialPlannerName"];
            this.rdsimsRequestNumber = _data["rdsimsRequestNumber"];
            this.requestNumber = _data["requestNumber"];
            this.alternativeProduct = _data["alternativeProduct"];
            this.materialPlanningGroupId = _data["materialPlanningGroupId"];
            this.dateNeeded = _data["dateNeeded"] ? new Date(_data["dateNeeded"].toString()) : <any>undefined;
            this.approvedAlternative = _data["approvedAlternative"];
            this.requestSubmissionDate = _data["requestSubmissionDate"] ? new Date(_data["requestSubmissionDate"].toString()) : <any>undefined;
            this.orderTypeId = _data["orderTypeId"];
            this.materialPurposeId = _data["materialPurposeId"];
            this.orderStatusId = _data["orderStatusId"];
            this.orderType = _data["orderType"] ? OrderTypeModel.fromJS(_data["orderType"], _mappings) : <any>undefined;
            this.forecastItem = _data["forecastItem"] ? ForecastItemModel.fromJS(_data["forecastItem"], _mappings) : <any>undefined;
            this.forecastItemDestination = _data["forecastItemDestination"] ? ForecastItemDestinationModel.fromJS(_data["forecastItemDestination"], _mappings) : <any>undefined;
            this.materialPurpose = _data["materialPurpose"] ? MaterialPurposeModel.fromJS(_data["materialPurpose"], _mappings) : <any>undefined;
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"], _mappings) : <any>undefined;
            this.lotNumber = _data["lotNumber"];
            this.inventoryLocation = _data["inventoryLocation"] ? SampleInventoryLocationModel.fromJS(_data["inventoryLocation"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemForecastDestinationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemForecastDestinationModel>(data, _mappings, OrderItemForecastDestinationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderItemDestinationId"] = this.orderItemDestinationId;
        data["forecastItemDestinationId"] = this.forecastItemDestinationId;
        data["country"] = this.country;
        data["forecastItemId"] = this.forecastItemId;
        data["quantity"] = this.quantity;
        data["unUsedQuantity"] = this.unUsedQuantity;
        data["quantityUomId"] = this.quantityUomId;
        data["uomDisplay"] = this.uomDisplay;
        data["isFulfilled"] = this.isFulfilled;
        data["isNonForecast"] = this.isNonForecast;
        data["requesterUserId"] = this.requesterUserId;
        data["requesterUser"] = this.requesterUser ? this.requesterUser.toJSON() : <any>undefined;
        data["requesterName"] = this.requesterName;
        data["materialPlannerName"] = this.materialPlannerName;
        data["rdsimsRequestNumber"] = this.rdsimsRequestNumber;
        data["requestNumber"] = this.requestNumber;
        data["alternativeProduct"] = this.alternativeProduct;
        data["materialPlanningGroupId"] = this.materialPlanningGroupId;
        data["dateNeeded"] = this.dateNeeded ? this.dateNeeded.toISOString() : <any>undefined;
        data["approvedAlternative"] = this.approvedAlternative;
        data["requestSubmissionDate"] = this.requestSubmissionDate ? this.requestSubmissionDate.toISOString() : <any>undefined;
        data["orderTypeId"] = this.orderTypeId;
        data["materialPurposeId"] = this.materialPurposeId;
        data["orderStatusId"] = this.orderStatusId;
        data["orderType"] = this.orderType ? this.orderType.toJSON() : <any>undefined;
        data["forecastItem"] = this.forecastItem ? this.forecastItem.toJSON() : <any>undefined;
        data["forecastItemDestination"] = this.forecastItemDestination ? this.forecastItemDestination.toJSON() : <any>undefined;
        data["materialPurpose"] = this.materialPurpose ? this.materialPurpose.toJSON() : <any>undefined;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        data["lotNumber"] = this.lotNumber;
        data["inventoryLocation"] = this.inventoryLocation ? this.inventoryLocation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderItemForecastDestinationModel {
    id?: number;
    orderItemDestinationId?: number;
    forecastItemDestinationId?: number | undefined;
    country?: string | undefined;
    forecastItemId?: number | undefined;
    quantity?: number;
    unUsedQuantity?: number;
    quantityUomId?: number;
    uomDisplay?: string | undefined;
    isFulfilled?: boolean;
    isNonForecast?: boolean;
    requesterUserId?: number | undefined;
    requesterUser?: UserModel;
    requesterName?: string | undefined;
    materialPlannerName?: string | undefined;
    rdsimsRequestNumber?: string | undefined;
    requestNumber?: string | undefined;
    alternativeProduct?: string | undefined;
    materialPlanningGroupId?: number | undefined;
    dateNeeded?: Date | undefined;
    approvedAlternative?: string | undefined;
    requestSubmissionDate?: Date | undefined;
    orderTypeId?: number | undefined;
    materialPurposeId?: number | undefined;
    orderStatusId?: number;
    orderType?: OrderTypeModel;
    forecastItem?: ForecastItemModel;
    forecastItemDestination?: ForecastItemDestinationModel;
    materialPurpose?: MaterialPurposeModel;
    orderStatus?: OrderStatusModel;
    lotNumber?: string | undefined;
    inventoryLocation?: SampleInventoryLocationModel;
}

export class OrderItemModel implements IOrderItemModel {
    id?: number;
    productName?: string | undefined;
    materialSearchType?: string | undefined;
    synonyms?: string | undefined;
    lotId?: string | undefined;
    lotNumber?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    brandName?: string | undefined;
    stage?: string | undefined;
    productType?: string | undefined;
    formulationType?: string | undefined;
    orderTypeId?: number;
    orderStatusId?: number;
    orderSubmissionDate?: Date | undefined;
    recertDate?: Date | undefined;
    earliestDateNeeded?: Date | undefined;
    formulationNumber?: string | undefined;
    formulationTypeId?: number | undefined;
    additionalQuantity?: number;
    quantityUomId?: number;
    gmidDcodeItemNumber?: string | undefined;
    approver?: string | undefined;
    isReachCompliant?: boolean;
    isManufactured?: boolean | undefined;
    createdByUserId?: number;
    createdByUserName?: string | undefined;
    createdDate?: Date;
    modifiedByUserName?: string | undefined;
    modifiedByUserId?: number;
    modifiedDate?: Date;
    shortfallQuantity?: number | undefined;
    quantityOrdered?: number | undefined;
    orderQuantityUomId?: number | undefined;
    orderQuantityUomName?: string | undefined;
    estimatedOrderQuantity?: number | undefined;
    estimatedOrderQuantityUomId?: number | undefined;
    estimatedOrderQuantityUomName?: string | undefined;
    orderConfirmationNumber?: string | undefined;
    supplierPlantCode?: string | undefined;
    forecastedQuantityWithUoms?: string | undefined;
    nonForecastedQuantityWithUoms?: string | undefined;
    sampleInventoryLocationId?: number | undefined;
    sgSinventoryProfile?: string | undefined;
    materialPlannerUserId?: number | undefined;
    materialPlannerUserName?: string | undefined;
    dirty?: boolean;
    orderStatus?: OrderStatusModel;
    orderStatusDropdown?: OrderStatusModel[] | undefined;
    orderItemActiveIngredient?: OrderItemActiveIngredientModel[] | undefined;
    orderItemComment?: OrderItemCommentModel[] | undefined;
    forecastItemCommentLog?: ForecastItemCommentLogModel[] | undefined;
    orderItemDestination?: OrderItemDestinationModel[] | undefined;
    orderItemShipment?: OrderItemShipmentModel[] | undefined;
    sampleInventoryLocation?: SampleInventoryLocationModel;
    orderQuantityUom?: UnitOfMeasureModel;
    estimatedOrderQuantityUom?: UnitOfMeasureModel;

    constructor(data?: IOrderItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.materialSearchType = _data["materialSearchType"];
            this.synonyms = _data["synonyms"];
            this.lotId = _data["lotId"];
            this.lotNumber = _data["lotNumber"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.brandName = _data["brandName"];
            this.stage = _data["stage"];
            this.productType = _data["productType"];
            this.formulationType = _data["formulationType"];
            this.orderTypeId = _data["orderTypeId"];
            this.orderStatusId = _data["orderStatusId"];
            this.orderSubmissionDate = _data["orderSubmissionDate"] ? new Date(_data["orderSubmissionDate"].toString()) : <any>undefined;
            this.recertDate = _data["recertDate"] ? new Date(_data["recertDate"].toString()) : <any>undefined;
            this.earliestDateNeeded = _data["earliestDateNeeded"] ? new Date(_data["earliestDateNeeded"].toString()) : <any>undefined;
            this.formulationNumber = _data["formulationNumber"];
            this.formulationTypeId = _data["formulationTypeId"];
            this.additionalQuantity = _data["additionalQuantity"];
            this.quantityUomId = _data["quantityUomId"];
            this.gmidDcodeItemNumber = _data["gmidDcodeItemNumber"];
            this.approver = _data["approver"];
            this.isReachCompliant = _data["isReachCompliant"];
            this.isManufactured = _data["isManufactured"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUserName = _data["createdByUserName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedByUserName = _data["modifiedByUserName"];
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.shortfallQuantity = _data["shortfallQuantity"];
            this.quantityOrdered = _data["quantityOrdered"];
            this.orderQuantityUomId = _data["orderQuantityUomId"];
            this.orderQuantityUomName = _data["orderQuantityUomName"];
            this.estimatedOrderQuantity = _data["estimatedOrderQuantity"];
            this.estimatedOrderQuantityUomId = _data["estimatedOrderQuantityUomId"];
            this.estimatedOrderQuantityUomName = _data["estimatedOrderQuantityUomName"];
            this.orderConfirmationNumber = _data["orderConfirmationNumber"];
            this.supplierPlantCode = _data["supplierPlantCode"];
            this.forecastedQuantityWithUoms = _data["forecastedQuantityWithUoms"];
            this.nonForecastedQuantityWithUoms = _data["nonForecastedQuantityWithUoms"];
            this.sampleInventoryLocationId = _data["sampleInventoryLocationId"];
            this.sgSinventoryProfile = _data["sgSinventoryProfile"];
            this.materialPlannerUserId = _data["materialPlannerUserId"];
            this.materialPlannerUserName = _data["materialPlannerUserName"];
            this.dirty = _data["dirty"];
            this.orderStatus = _data["orderStatus"] ? OrderStatusModel.fromJS(_data["orderStatus"], _mappings) : <any>undefined;
            if (Array.isArray(_data["orderStatusDropdown"])) {
                this.orderStatusDropdown = [] as any;
                for (let item of _data["orderStatusDropdown"])
                    this.orderStatusDropdown.push(OrderStatusModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["orderItemActiveIngredient"])) {
                this.orderItemActiveIngredient = [] as any;
                for (let item of _data["orderItemActiveIngredient"])
                    this.orderItemActiveIngredient.push(OrderItemActiveIngredientModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["orderItemComment"])) {
                this.orderItemComment = [] as any;
                for (let item of _data["orderItemComment"])
                    this.orderItemComment.push(OrderItemCommentModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["forecastItemCommentLog"])) {
                this.forecastItemCommentLog = [] as any;
                for (let item of _data["forecastItemCommentLog"])
                    this.forecastItemCommentLog.push(ForecastItemCommentLogModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["orderItemDestination"])) {
                this.orderItemDestination = [] as any;
                for (let item of _data["orderItemDestination"])
                    this.orderItemDestination.push(OrderItemDestinationModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["orderItemShipment"])) {
                this.orderItemShipment = [] as any;
                for (let item of _data["orderItemShipment"])
                    this.orderItemShipment.push(OrderItemShipmentModel.fromJS(item, _mappings));
            }
            this.sampleInventoryLocation = _data["sampleInventoryLocation"] ? SampleInventoryLocationModel.fromJS(_data["sampleInventoryLocation"], _mappings) : <any>undefined;
            this.orderQuantityUom = _data["orderQuantityUom"] ? UnitOfMeasureModel.fromJS(_data["orderQuantityUom"], _mappings) : <any>undefined;
            this.estimatedOrderQuantityUom = _data["estimatedOrderQuantityUom"] ? UnitOfMeasureModel.fromJS(_data["estimatedOrderQuantityUom"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemModel>(data, _mappings, OrderItemModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["materialSearchType"] = this.materialSearchType;
        data["synonyms"] = this.synonyms;
        data["lotId"] = this.lotId;
        data["lotNumber"] = this.lotNumber;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["brandName"] = this.brandName;
        data["stage"] = this.stage;
        data["productType"] = this.productType;
        data["formulationType"] = this.formulationType;
        data["orderTypeId"] = this.orderTypeId;
        data["orderStatusId"] = this.orderStatusId;
        data["orderSubmissionDate"] = this.orderSubmissionDate ? this.orderSubmissionDate.toISOString() : <any>undefined;
        data["recertDate"] = this.recertDate ? this.recertDate.toISOString() : <any>undefined;
        data["earliestDateNeeded"] = this.earliestDateNeeded ? this.earliestDateNeeded.toISOString() : <any>undefined;
        data["formulationNumber"] = this.formulationNumber;
        data["formulationTypeId"] = this.formulationTypeId;
        data["additionalQuantity"] = this.additionalQuantity;
        data["quantityUomId"] = this.quantityUomId;
        data["gmidDcodeItemNumber"] = this.gmidDcodeItemNumber;
        data["approver"] = this.approver;
        data["isReachCompliant"] = this.isReachCompliant;
        data["isManufactured"] = this.isManufactured;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUserName"] = this.createdByUserName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedByUserName"] = this.modifiedByUserName;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["shortfallQuantity"] = this.shortfallQuantity;
        data["quantityOrdered"] = this.quantityOrdered;
        data["orderQuantityUomId"] = this.orderQuantityUomId;
        data["orderQuantityUomName"] = this.orderQuantityUomName;
        data["estimatedOrderQuantity"] = this.estimatedOrderQuantity;
        data["estimatedOrderQuantityUomId"] = this.estimatedOrderQuantityUomId;
        data["estimatedOrderQuantityUomName"] = this.estimatedOrderQuantityUomName;
        data["orderConfirmationNumber"] = this.orderConfirmationNumber;
        data["supplierPlantCode"] = this.supplierPlantCode;
        data["forecastedQuantityWithUoms"] = this.forecastedQuantityWithUoms;
        data["nonForecastedQuantityWithUoms"] = this.nonForecastedQuantityWithUoms;
        data["sampleInventoryLocationId"] = this.sampleInventoryLocationId;
        data["sgSinventoryProfile"] = this.sgSinventoryProfile;
        data["materialPlannerUserId"] = this.materialPlannerUserId;
        data["materialPlannerUserName"] = this.materialPlannerUserName;
        data["dirty"] = this.dirty;
        data["orderStatus"] = this.orderStatus ? this.orderStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.orderStatusDropdown)) {
            data["orderStatusDropdown"] = [];
            for (let item of this.orderStatusDropdown)
                data["orderStatusDropdown"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemActiveIngredient)) {
            data["orderItemActiveIngredient"] = [];
            for (let item of this.orderItemActiveIngredient)
                data["orderItemActiveIngredient"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemComment)) {
            data["orderItemComment"] = [];
            for (let item of this.orderItemComment)
                data["orderItemComment"].push(item.toJSON());
        }
        if (Array.isArray(this.forecastItemCommentLog)) {
            data["forecastItemCommentLog"] = [];
            for (let item of this.forecastItemCommentLog)
                data["forecastItemCommentLog"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemDestination)) {
            data["orderItemDestination"] = [];
            for (let item of this.orderItemDestination)
                data["orderItemDestination"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemShipment)) {
            data["orderItemShipment"] = [];
            for (let item of this.orderItemShipment)
                data["orderItemShipment"].push(item.toJSON());
        }
        data["sampleInventoryLocation"] = this.sampleInventoryLocation ? this.sampleInventoryLocation.toJSON() : <any>undefined;
        data["orderQuantityUom"] = this.orderQuantityUom ? this.orderQuantityUom.toJSON() : <any>undefined;
        data["estimatedOrderQuantityUom"] = this.estimatedOrderQuantityUom ? this.estimatedOrderQuantityUom.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderItemModel {
    id?: number;
    productName?: string | undefined;
    materialSearchType?: string | undefined;
    synonyms?: string | undefined;
    lotId?: string | undefined;
    lotNumber?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    brandName?: string | undefined;
    stage?: string | undefined;
    productType?: string | undefined;
    formulationType?: string | undefined;
    orderTypeId?: number;
    orderStatusId?: number;
    orderSubmissionDate?: Date | undefined;
    recertDate?: Date | undefined;
    earliestDateNeeded?: Date | undefined;
    formulationNumber?: string | undefined;
    formulationTypeId?: number | undefined;
    additionalQuantity?: number;
    quantityUomId?: number;
    gmidDcodeItemNumber?: string | undefined;
    approver?: string | undefined;
    isReachCompliant?: boolean;
    isManufactured?: boolean | undefined;
    createdByUserId?: number;
    createdByUserName?: string | undefined;
    createdDate?: Date;
    modifiedByUserName?: string | undefined;
    modifiedByUserId?: number;
    modifiedDate?: Date;
    shortfallQuantity?: number | undefined;
    quantityOrdered?: number | undefined;
    orderQuantityUomId?: number | undefined;
    orderQuantityUomName?: string | undefined;
    estimatedOrderQuantity?: number | undefined;
    estimatedOrderQuantityUomId?: number | undefined;
    estimatedOrderQuantityUomName?: string | undefined;
    orderConfirmationNumber?: string | undefined;
    supplierPlantCode?: string | undefined;
    forecastedQuantityWithUoms?: string | undefined;
    nonForecastedQuantityWithUoms?: string | undefined;
    sampleInventoryLocationId?: number | undefined;
    sgSinventoryProfile?: string | undefined;
    materialPlannerUserId?: number | undefined;
    materialPlannerUserName?: string | undefined;
    dirty?: boolean;
    orderStatus?: OrderStatusModel;
    orderStatusDropdown?: OrderStatusModel[] | undefined;
    orderItemActiveIngredient?: OrderItemActiveIngredientModel[] | undefined;
    orderItemComment?: OrderItemCommentModel[] | undefined;
    forecastItemCommentLog?: ForecastItemCommentLogModel[] | undefined;
    orderItemDestination?: OrderItemDestinationModel[] | undefined;
    orderItemShipment?: OrderItemShipmentModel[] | undefined;
    sampleInventoryLocation?: SampleInventoryLocationModel;
    orderQuantityUom?: UnitOfMeasureModel;
    estimatedOrderQuantityUom?: UnitOfMeasureModel;
}

export class OrderItemResult implements IOrderItemResult {
    totalCount?: number;
    orderItems?: OrderItemModel[] | undefined;

    constructor(data?: IOrderItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems.push(OrderItemModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemResult>(data, _mappings, OrderItemResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderItemResult {
    totalCount?: number;
    orderItems?: OrderItemModel[] | undefined;
}

export class OrderItemShipmentModel implements IOrderItemShipmentModel {
    id?: number;
    orderItemId?: number;
    dateReceived?: Date | undefined;
    totalQuantityReceived?: number | undefined;
    receivedQuantityUom?: UnitOfMeasureModel;
    supplierPlantCode?: string | undefined;
    lotNumber?: string | undefined;
    tsnNumber?: string | undefined;
    eccSupplierConfirmationNumber?: string | undefined;
    certificateOfAnalysisFlag?: boolean | undefined;
    defectId?: number | undefined;
    defectCreatedDate?: Date | undefined;
    defectResolvedDate?: Date | undefined;
    defectReasonText?: string | undefined;
    sourceId?: number | undefined;
    procurementTime?: number | undefined;
    defectDuration?: number | undefined;
    createdByUserId?: number | undefined;
    createdByUser?: UserModel;
    defect?: ShipmentDefectModel;
    receiptStatus?: ReceiptStatusModel;

    constructor(data?: IOrderItemShipmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderItemId = _data["orderItemId"];
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.totalQuantityReceived = _data["totalQuantityReceived"];
            this.receivedQuantityUom = _data["receivedQuantityUom"] ? UnitOfMeasureModel.fromJS(_data["receivedQuantityUom"], _mappings) : <any>undefined;
            this.supplierPlantCode = _data["supplierPlantCode"];
            this.lotNumber = _data["lotNumber"];
            this.tsnNumber = _data["tsnNumber"];
            this.eccSupplierConfirmationNumber = _data["eccSupplierConfirmationNumber"];
            this.certificateOfAnalysisFlag = _data["certificateOfAnalysisFlag"];
            this.defectId = _data["defectId"];
            this.defectCreatedDate = _data["defectCreatedDate"] ? new Date(_data["defectCreatedDate"].toString()) : <any>undefined;
            this.defectResolvedDate = _data["defectResolvedDate"] ? new Date(_data["defectResolvedDate"].toString()) : <any>undefined;
            this.defectReasonText = _data["defectReasonText"];
            this.sourceId = _data["sourceId"];
            this.procurementTime = _data["procurementTime"];
            this.defectDuration = _data["defectDuration"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUser = _data["createdByUser"] ? UserModel.fromJS(_data["createdByUser"], _mappings) : <any>undefined;
            this.defect = _data["defect"] ? ShipmentDefectModel.fromJS(_data["defect"], _mappings) : <any>undefined;
            this.receiptStatus = _data["receiptStatus"] ? ReceiptStatusModel.fromJS(_data["receiptStatus"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemShipmentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemShipmentModel>(data, _mappings, OrderItemShipmentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderItemId"] = this.orderItemId;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["totalQuantityReceived"] = this.totalQuantityReceived;
        data["receivedQuantityUom"] = this.receivedQuantityUom ? this.receivedQuantityUom.toJSON() : <any>undefined;
        data["supplierPlantCode"] = this.supplierPlantCode;
        data["lotNumber"] = this.lotNumber;
        data["tsnNumber"] = this.tsnNumber;
        data["eccSupplierConfirmationNumber"] = this.eccSupplierConfirmationNumber;
        data["certificateOfAnalysisFlag"] = this.certificateOfAnalysisFlag;
        data["defectId"] = this.defectId;
        data["defectCreatedDate"] = this.defectCreatedDate ? this.defectCreatedDate.toISOString() : <any>undefined;
        data["defectResolvedDate"] = this.defectResolvedDate ? this.defectResolvedDate.toISOString() : <any>undefined;
        data["defectReasonText"] = this.defectReasonText;
        data["sourceId"] = this.sourceId;
        data["procurementTime"] = this.procurementTime;
        data["defectDuration"] = this.defectDuration;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : <any>undefined;
        data["defect"] = this.defect ? this.defect.toJSON() : <any>undefined;
        data["receiptStatus"] = this.receiptStatus ? this.receiptStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderItemShipmentModel {
    id?: number;
    orderItemId?: number;
    dateReceived?: Date | undefined;
    totalQuantityReceived?: number | undefined;
    receivedQuantityUom?: UnitOfMeasureModel;
    supplierPlantCode?: string | undefined;
    lotNumber?: string | undefined;
    tsnNumber?: string | undefined;
    eccSupplierConfirmationNumber?: string | undefined;
    certificateOfAnalysisFlag?: boolean | undefined;
    defectId?: number | undefined;
    defectCreatedDate?: Date | undefined;
    defectResolvedDate?: Date | undefined;
    defectReasonText?: string | undefined;
    sourceId?: number | undefined;
    procurementTime?: number | undefined;
    defectDuration?: number | undefined;
    createdByUserId?: number | undefined;
    createdByUser?: UserModel;
    defect?: ShipmentDefectModel;
    receiptStatus?: ReceiptStatusModel;
}

export class OrderSearchRequest implements IOrderSearchRequest {
    filterId?: number;
    plantCode?: string | undefined;
    orderNumber?: string | undefined;
    product?: string | undefined;
    formulationNumber?: string | undefined;
    filterName?: string | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    statusIds?: number[] | undefined;
    keyword?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    userId?: number;
    materialPlannerId?: number | undefined;
    forecasterId?: number | undefined;
    forecastNumber?: number | undefined;
    toDate?: string | undefined;
    fromDate?: string | undefined;

    constructor(data?: IOrderSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            this.plantCode = _data["plantCode"];
            this.orderNumber = _data["orderNumber"];
            this.product = _data["product"];
            this.formulationNumber = _data["formulationNumber"];
            this.filterName = _data["filterName"];
            this.sortOrder = _data["sortOrder"];
            this.isASC = _data["isASC"];
            if (Array.isArray(_data["statusIds"])) {
                this.statusIds = [] as any;
                for (let item of _data["statusIds"])
                    this.statusIds.push(item);
            }
            this.keyword = _data["keyword"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.userId = _data["userId"];
            this.materialPlannerId = _data["materialPlannerId"];
            this.forecasterId = _data["forecasterId"];
            this.forecastNumber = _data["forecastNumber"];
            this.toDate = _data["toDate"];
            this.fromDate = _data["fromDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderSearchRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderSearchRequest>(data, _mappings, OrderSearchRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        data["plantCode"] = this.plantCode;
        data["orderNumber"] = this.orderNumber;
        data["product"] = this.product;
        data["formulationNumber"] = this.formulationNumber;
        data["filterName"] = this.filterName;
        data["sortOrder"] = this.sortOrder;
        data["isASC"] = this.isASC;
        if (Array.isArray(this.statusIds)) {
            data["statusIds"] = [];
            for (let item of this.statusIds)
                data["statusIds"].push(item);
        }
        data["keyword"] = this.keyword;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["userId"] = this.userId;
        data["materialPlannerId"] = this.materialPlannerId;
        data["forecasterId"] = this.forecasterId;
        data["forecastNumber"] = this.forecastNumber;
        data["toDate"] = this.toDate;
        data["fromDate"] = this.fromDate;
        return data;
    }
}

export interface IOrderSearchRequest {
    filterId?: number;
    plantCode?: string | undefined;
    orderNumber?: string | undefined;
    product?: string | undefined;
    formulationNumber?: string | undefined;
    filterName?: string | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    statusIds?: number[] | undefined;
    keyword?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    userId?: number;
    materialPlannerId?: number | undefined;
    forecasterId?: number | undefined;
    forecastNumber?: number | undefined;
    toDate?: string | undefined;
    fromDate?: string | undefined;
}

export class OrderStatusModel implements IOrderStatusModel {
    id?: number;
    status?: string | undefined;

    constructor(data?: IOrderStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderStatusModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderStatusModel>(data, _mappings, OrderStatusModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IOrderStatusModel {
    id?: number;
    status?: string | undefined;
}

export class OrderTypeModel implements IOrderTypeModel {
    id?: number;
    orderType1?: string | undefined;

    constructor(data?: IOrderTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderType1 = _data["orderType1"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderTypeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderTypeModel>(data, _mappings, OrderTypeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderType1"] = this.orderType1;
        return data;
    }
}

export interface IOrderTypeModel {
    id?: number;
    orderType1?: string | undefined;
}

export class PlannerItem implements IPlannerItem {
    seedForecastItemId?: number;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    brandName?: string | undefined;
    formulationType?: string | undefined;
    quantityWithUomBreakup?: string | undefined;
    formulationTypeId?: number | undefined;
    formulationTypeCode?: string | undefined;
    productType?: string | undefined;
    higherStatus?: string | undefined;
    isNew?: boolean;
    formulationTypeName?: string | undefined;
    totalNumberOfDestinations?: number;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    dateRange?: string | undefined;
    earliestDateNeeded?: Date | undefined;
    materialPlannerUserId?: number | undefined;
    materialPlannerUserName?: string | undefined;
    materialPlanningGroupId?: string | undefined;
    stage?: string | undefined;
    stateName?: string | undefined;
    forecastType?: string | undefined;
    forecaster?: string | undefined;
    stateId?: number;
    bypassReservation?: boolean;
    isExcludeGLPforSGS?: boolean;
    destinations?: ForecastItemDestinationModel[] | undefined;
    activeIngredient?: ForecastItemActiveIngredientModel[] | undefined;

    constructor(data?: IPlannerItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.seedForecastItemId = _data["seedForecastItemId"];
            this.materialName = _data["materialName"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.brandName = _data["brandName"];
            this.formulationType = _data["formulationType"];
            this.quantityWithUomBreakup = _data["quantityWithUomBreakup"];
            this.formulationTypeId = _data["formulationTypeId"];
            this.formulationTypeCode = _data["formulationTypeCode"];
            this.productType = _data["productType"];
            this.higherStatus = _data["higherStatus"];
            this.isNew = _data["isNew"];
            this.formulationTypeName = _data["formulationTypeName"];
            this.totalNumberOfDestinations = _data["totalNumberOfDestinations"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.dateRange = _data["dateRange"];
            this.earliestDateNeeded = _data["earliestDateNeeded"] ? new Date(_data["earliestDateNeeded"].toString()) : <any>undefined;
            this.materialPlannerUserId = _data["materialPlannerUserId"];
            this.materialPlannerUserName = _data["materialPlannerUserName"];
            this.materialPlanningGroupId = _data["materialPlanningGroupId"];
            this.stage = _data["stage"];
            this.stateName = _data["stateName"];
            this.forecastType = _data["forecastType"];
            this.forecaster = _data["forecaster"];
            this.stateId = _data["stateId"];
            this.bypassReservation = _data["bypassReservation"];
            this.isExcludeGLPforSGS = _data["isExcludeGLPforSGS"];
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations.push(ForecastItemDestinationModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["activeIngredient"])) {
                this.activeIngredient = [] as any;
                for (let item of _data["activeIngredient"])
                    this.activeIngredient.push(ForecastItemActiveIngredientModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PlannerItem | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PlannerItem>(data, _mappings, PlannerItem);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seedForecastItemId"] = this.seedForecastItemId;
        data["materialName"] = this.materialName;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["brandName"] = this.brandName;
        data["formulationType"] = this.formulationType;
        data["quantityWithUomBreakup"] = this.quantityWithUomBreakup;
        data["formulationTypeId"] = this.formulationTypeId;
        data["formulationTypeCode"] = this.formulationTypeCode;
        data["productType"] = this.productType;
        data["higherStatus"] = this.higherStatus;
        data["isNew"] = this.isNew;
        data["formulationTypeName"] = this.formulationTypeName;
        data["totalNumberOfDestinations"] = this.totalNumberOfDestinations;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["dateRange"] = this.dateRange;
        data["earliestDateNeeded"] = this.earliestDateNeeded ? this.earliestDateNeeded.toISOString() : <any>undefined;
        data["materialPlannerUserId"] = this.materialPlannerUserId;
        data["materialPlannerUserName"] = this.materialPlannerUserName;
        data["materialPlanningGroupId"] = this.materialPlanningGroupId;
        data["stage"] = this.stage;
        data["stateName"] = this.stateName;
        data["forecastType"] = this.forecastType;
        data["forecaster"] = this.forecaster;
        data["stateId"] = this.stateId;
        data["bypassReservation"] = this.bypassReservation;
        data["isExcludeGLPforSGS"] = this.isExcludeGLPforSGS;
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item.toJSON());
        }
        if (Array.isArray(this.activeIngredient)) {
            data["activeIngredient"] = [];
            for (let item of this.activeIngredient)
                data["activeIngredient"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlannerItem {
    seedForecastItemId?: number;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    brandName?: string | undefined;
    formulationType?: string | undefined;
    quantityWithUomBreakup?: string | undefined;
    formulationTypeId?: number | undefined;
    formulationTypeCode?: string | undefined;
    productType?: string | undefined;
    higherStatus?: string | undefined;
    isNew?: boolean;
    formulationTypeName?: string | undefined;
    totalNumberOfDestinations?: number;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    dateRange?: string | undefined;
    earliestDateNeeded?: Date | undefined;
    materialPlannerUserId?: number | undefined;
    materialPlannerUserName?: string | undefined;
    materialPlanningGroupId?: string | undefined;
    stage?: string | undefined;
    stateName?: string | undefined;
    forecastType?: string | undefined;
    forecaster?: string | undefined;
    stateId?: number;
    bypassReservation?: boolean;
    isExcludeGLPforSGS?: boolean;
    destinations?: ForecastItemDestinationModel[] | undefined;
    activeIngredient?: ForecastItemActiveIngredientModel[] | undefined;
}

export class PlannerItemDetail implements IPlannerItemDetail {
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    brandName?: string | undefined;
    quantityWithUomBreakup?: string | undefined;
    formulationTypeId?: number;
    formulationTypeCode?: string | undefined;
    formulationTypeName?: string | undefined;
    formulationType?: string | undefined;
    totalNumberOfDestinations?: number;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    dateRange?: string | undefined;
    materialPlannerUserId?: number;
    materialPlannerUserName?: string | undefined;
    activeIngredients?: ForecastItemActiveIngredientModel[] | undefined;
    destinations?: ForecastItemDestinationModel[] | undefined;

    constructor(data?: IPlannerItemDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.materialName = _data["materialName"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.brandName = _data["brandName"];
            this.quantityWithUomBreakup = _data["quantityWithUomBreakup"];
            this.formulationTypeId = _data["formulationTypeId"];
            this.formulationTypeCode = _data["formulationTypeCode"];
            this.formulationTypeName = _data["formulationTypeName"];
            this.formulationType = _data["formulationType"];
            this.totalNumberOfDestinations = _data["totalNumberOfDestinations"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.dateRange = _data["dateRange"];
            this.materialPlannerUserId = _data["materialPlannerUserId"];
            this.materialPlannerUserName = _data["materialPlannerUserName"];
            if (Array.isArray(_data["activeIngredients"])) {
                this.activeIngredients = [] as any;
                for (let item of _data["activeIngredients"])
                    this.activeIngredients.push(ForecastItemActiveIngredientModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["destinations"])) {
                this.destinations = [] as any;
                for (let item of _data["destinations"])
                    this.destinations.push(ForecastItemDestinationModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PlannerItemDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PlannerItemDetail>(data, _mappings, PlannerItemDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialName"] = this.materialName;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["brandName"] = this.brandName;
        data["quantityWithUomBreakup"] = this.quantityWithUomBreakup;
        data["formulationTypeId"] = this.formulationTypeId;
        data["formulationTypeCode"] = this.formulationTypeCode;
        data["formulationTypeName"] = this.formulationTypeName;
        data["formulationType"] = this.formulationType;
        data["totalNumberOfDestinations"] = this.totalNumberOfDestinations;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["dateRange"] = this.dateRange;
        data["materialPlannerUserId"] = this.materialPlannerUserId;
        data["materialPlannerUserName"] = this.materialPlannerUserName;
        if (Array.isArray(this.activeIngredients)) {
            data["activeIngredients"] = [];
            for (let item of this.activeIngredients)
                data["activeIngredients"].push(item.toJSON());
        }
        if (Array.isArray(this.destinations)) {
            data["destinations"] = [];
            for (let item of this.destinations)
                data["destinations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlannerItemDetail {
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    brandName?: string | undefined;
    quantityWithUomBreakup?: string | undefined;
    formulationTypeId?: number;
    formulationTypeCode?: string | undefined;
    formulationTypeName?: string | undefined;
    formulationType?: string | undefined;
    totalNumberOfDestinations?: number;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    dateRange?: string | undefined;
    materialPlannerUserId?: number;
    materialPlannerUserName?: string | undefined;
    activeIngredients?: ForecastItemActiveIngredientModel[] | undefined;
    destinations?: ForecastItemDestinationModel[] | undefined;
}

export class PlannerItemResult implements IPlannerItemResult {
    totalCount?: number;
    plannerItems?: PlannerItem[] | undefined;

    constructor(data?: IPlannerItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["plannerItems"])) {
                this.plannerItems = [] as any;
                for (let item of _data["plannerItems"])
                    this.plannerItems.push(PlannerItem.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PlannerItemResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PlannerItemResult>(data, _mappings, PlannerItemResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.plannerItems)) {
            data["plannerItems"] = [];
            for (let item of this.plannerItems)
                data["plannerItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlannerItemResult {
    totalCount?: number;
    plannerItems?: PlannerItem[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProblemDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProblemDetails>(data, _mappings, ProblemDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProductCountries implements IProductCountries {
    countryCode?: string | undefined;
    exportTariffCode?: string | undefined;
    importTariffCode?: string | undefined;
    eccn?: string | undefined;
    manualHold?: string | undefined;
    holdStatus?: string | undefined;

    constructor(data?: IProductCountries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.exportTariffCode = _data["exportTariffCode"];
            this.importTariffCode = _data["importTariffCode"];
            this.eccn = _data["eccn"];
            this.manualHold = _data["manualHold"];
            this.holdStatus = _data["holdStatus"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductCountries | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductCountries>(data, _mappings, ProductCountries);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["exportTariffCode"] = this.exportTariffCode;
        data["importTariffCode"] = this.importTariffCode;
        data["eccn"] = this.eccn;
        data["manualHold"] = this.manualHold;
        data["holdStatus"] = this.holdStatus;
        return data;
    }
}

export interface IProductCountries {
    countryCode?: string | undefined;
    exportTariffCode?: string | undefined;
    importTariffCode?: string | undefined;
    eccn?: string | undefined;
    manualHold?: string | undefined;
    holdStatus?: string | undefined;
}

export class ProductResult implements IProductResult {
    productId?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    manualHold?: boolean;
    holdStatus?: boolean;
    productCountries?: ProductCountries[] | undefined;

    constructor(data?: IProductResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productDescription = _data["productDescription"];
            this.productFamily = _data["productFamily"];
            this.manualHold = _data["manualHold"];
            this.holdStatus = _data["holdStatus"];
            if (Array.isArray(_data["productCountries"])) {
                this.productCountries = [] as any;
                for (let item of _data["productCountries"])
                    this.productCountries.push(ProductCountries.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductResult>(data, _mappings, ProductResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productDescription"] = this.productDescription;
        data["productFamily"] = this.productFamily;
        data["manualHold"] = this.manualHold;
        data["holdStatus"] = this.holdStatus;
        if (Array.isArray(this.productCountries)) {
            data["productCountries"] = [];
            for (let item of this.productCountries)
                data["productCountries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductResult {
    productId?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    manualHold?: boolean;
    holdStatus?: boolean;
    productCountries?: ProductCountries[] | undefined;
}

export class QuantityUnitOfMeasureModel implements IQuantityUnitOfMeasureModel {
    id?: number;
    uomDisplay?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
    sortOrder?: number;

    constructor(data?: IQuantityUnitOfMeasureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uomDisplay = _data["uomDisplay"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): QuantityUnitOfMeasureModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<QuantityUnitOfMeasureModel>(data, _mappings, QuantityUnitOfMeasureModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uomDisplay"] = this.uomDisplay;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IQuantityUnitOfMeasureModel {
    id?: number;
    uomDisplay?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
    sortOrder?: number;
}

export class RawMaterialCompositionModel implements IRawMaterialCompositionModel {
    id?: number;
    programNumber?: string | undefined;
    forecastItemId?: number;
    materialId?: string | undefined;
    materialName?: string | undefined;
    procurementStatus?: number;
    quantityRequested?: number;
    orderQuantityUomId?: number;
    expiredAcceptable?: boolean;
    reachApproved?: boolean;
    qualified?: string | undefined;
    excelInclusion?: boolean;
    excelDate?: Date | undefined;
    createDate?: Date | undefined;
    createdByUserId?: number;
    modifiedDate?: Date | undefined;
    modifiedByUserId?: number;
    isCancelled?: boolean;
    isGLP?: boolean;
    lotNumber?: string | undefined;
    targetForecastItemDestinationId?: number | undefined;
    repoName?: string | undefined;

    constructor(data?: IRawMaterialCompositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.programNumber = _data["programNumber"];
            this.forecastItemId = _data["forecastItemId"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
            this.procurementStatus = _data["procurementStatus"];
            this.quantityRequested = _data["quantityRequested"];
            this.orderQuantityUomId = _data["orderQuantityUomId"];
            this.expiredAcceptable = _data["expiredAcceptable"];
            this.reachApproved = _data["reachApproved"];
            this.qualified = _data["qualified"];
            this.excelInclusion = _data["excelInclusion"];
            this.excelDate = _data["excelDate"] ? new Date(_data["excelDate"].toString()) : <any>undefined;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.createdByUserId = _data["createdByUserId"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedByUserId = _data["modifiedByUserId"];
            this.isCancelled = _data["isCancelled"];
            this.isGLP = _data["isGLP"];
            this.lotNumber = _data["lotNumber"];
            this.targetForecastItemDestinationId = _data["targetForecastItemDestinationId"];
            this.repoName = _data["repoName"];
        }
    }

    static fromJS(data: any, _mappings?: any): RawMaterialCompositionModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RawMaterialCompositionModel>(data, _mappings, RawMaterialCompositionModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["programNumber"] = this.programNumber;
        data["forecastItemId"] = this.forecastItemId;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["procurementStatus"] = this.procurementStatus;
        data["quantityRequested"] = this.quantityRequested;
        data["orderQuantityUomId"] = this.orderQuantityUomId;
        data["expiredAcceptable"] = this.expiredAcceptable;
        data["reachApproved"] = this.reachApproved;
        data["qualified"] = this.qualified;
        data["excelInclusion"] = this.excelInclusion;
        data["excelDate"] = this.excelDate ? this.excelDate.toISOString() : <any>undefined;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["createdByUserId"] = this.createdByUserId;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedByUserId"] = this.modifiedByUserId;
        data["isCancelled"] = this.isCancelled;
        data["isGLP"] = this.isGLP;
        data["lotNumber"] = this.lotNumber;
        data["targetForecastItemDestinationId"] = this.targetForecastItemDestinationId;
        data["repoName"] = this.repoName;
        return data;
    }
}

export interface IRawMaterialCompositionModel {
    id?: number;
    programNumber?: string | undefined;
    forecastItemId?: number;
    materialId?: string | undefined;
    materialName?: string | undefined;
    procurementStatus?: number;
    quantityRequested?: number;
    orderQuantityUomId?: number;
    expiredAcceptable?: boolean;
    reachApproved?: boolean;
    qualified?: string | undefined;
    excelInclusion?: boolean;
    excelDate?: Date | undefined;
    createDate?: Date | undefined;
    createdByUserId?: number;
    modifiedDate?: Date | undefined;
    modifiedByUserId?: number;
    isCancelled?: boolean;
    isGLP?: boolean;
    lotNumber?: string | undefined;
    targetForecastItemDestinationId?: number | undefined;
    repoName?: string | undefined;
}

export class RawMaterialDelegateDesignationModel implements IRawMaterialDelegateDesignationModel {
    programNumber?: string | undefined;
    delegateId?: number;
    createdByUserId?: number;

    constructor(data?: IRawMaterialDelegateDesignationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.programNumber = _data["programNumber"];
            this.delegateId = _data["delegateId"];
            this.createdByUserId = _data["createdByUserId"];
        }
    }

    static fromJS(data: any, _mappings?: any): RawMaterialDelegateDesignationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RawMaterialDelegateDesignationModel>(data, _mappings, RawMaterialDelegateDesignationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programNumber"] = this.programNumber;
        data["delegateId"] = this.delegateId;
        data["createdByUserId"] = this.createdByUserId;
        return data;
    }
}

export interface IRawMaterialDelegateDesignationModel {
    programNumber?: string | undefined;
    delegateId?: number;
    createdByUserId?: number;
}

export class RawMaterialFilterModel implements IRawMaterialFilterModel {
    productionOwnerId?: number | undefined;
    forecasterId?: number | undefined;
    materialPlannerId?: number | undefined;
    formulation?: string | undefined;
    programNumber?: string | undefined;
    productionLocationId?: number | undefined;
    statusIdList?: number[] | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;

    constructor(data?: IRawMaterialFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productionOwnerId = _data["productionOwnerId"];
            this.forecasterId = _data["forecasterId"];
            this.materialPlannerId = _data["materialPlannerId"];
            this.formulation = _data["formulation"];
            this.programNumber = _data["programNumber"];
            this.productionLocationId = _data["productionLocationId"];
            if (Array.isArray(_data["statusIdList"])) {
                this.statusIdList = [] as any;
                for (let item of _data["statusIdList"])
                    this.statusIdList.push(item);
            }
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
        }
    }

    static fromJS(data: any, _mappings?: any): RawMaterialFilterModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RawMaterialFilterModel>(data, _mappings, RawMaterialFilterModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionOwnerId"] = this.productionOwnerId;
        data["forecasterId"] = this.forecasterId;
        data["materialPlannerId"] = this.materialPlannerId;
        data["formulation"] = this.formulation;
        data["programNumber"] = this.programNumber;
        data["productionLocationId"] = this.productionLocationId;
        if (Array.isArray(this.statusIdList)) {
            data["statusIdList"] = [];
            for (let item of this.statusIdList)
                data["statusIdList"].push(item);
        }
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        return data;
    }
}

export interface IRawMaterialFilterModel {
    productionOwnerId?: number | undefined;
    forecasterId?: number | undefined;
    materialPlannerId?: number | undefined;
    formulation?: string | undefined;
    programNumber?: string | undefined;
    productionLocationId?: number | undefined;
    statusIdList?: number[] | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
}

export class RawMaterialProductionModel implements IRawMaterialProductionModel {
    programNumber?: string | undefined;
    productionLocationId?: number | undefined;
    productionOwnerId?: number | undefined;
    status?: string | undefined;
    managerEmail?: string | undefined;
    productionOwnerEmail?: string | undefined;
    productionOwnerName?: string | undefined;

    constructor(data?: IRawMaterialProductionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.programNumber = _data["programNumber"];
            this.productionLocationId = _data["productionLocationId"];
            this.productionOwnerId = _data["productionOwnerId"];
            this.status = _data["status"];
            this.managerEmail = _data["managerEmail"];
            this.productionOwnerEmail = _data["productionOwnerEmail"];
            this.productionOwnerName = _data["productionOwnerName"];
        }
    }

    static fromJS(data: any, _mappings?: any): RawMaterialProductionModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RawMaterialProductionModel>(data, _mappings, RawMaterialProductionModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programNumber"] = this.programNumber;
        data["productionLocationId"] = this.productionLocationId;
        data["productionOwnerId"] = this.productionOwnerId;
        data["status"] = this.status;
        data["managerEmail"] = this.managerEmail;
        data["productionOwnerEmail"] = this.productionOwnerEmail;
        data["productionOwnerName"] = this.productionOwnerName;
        return data;
    }
}

export interface IRawMaterialProductionModel {
    programNumber?: string | undefined;
    productionLocationId?: number | undefined;
    productionOwnerId?: number | undefined;
    status?: string | undefined;
    managerEmail?: string | undefined;
    productionOwnerEmail?: string | undefined;
    productionOwnerName?: string | undefined;
}

export class RawMaterialShippingAddressModel implements IRawMaterialShippingAddressModel {
    programNumber?: string | undefined;
    cpssShipAddressId?: number;
    recipientEmail?: string | undefined;

    constructor(data?: IRawMaterialShippingAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.programNumber = _data["programNumber"];
            this.cpssShipAddressId = _data["cpssShipAddressId"];
            this.recipientEmail = _data["recipientEmail"];
        }
    }

    static fromJS(data: any, _mappings?: any): RawMaterialShippingAddressModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RawMaterialShippingAddressModel>(data, _mappings, RawMaterialShippingAddressModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programNumber"] = this.programNumber;
        data["cpssShipAddressId"] = this.cpssShipAddressId;
        data["recipientEmail"] = this.recipientEmail;
        return data;
    }
}

export interface IRawMaterialShippingAddressModel {
    programNumber?: string | undefined;
    cpssShipAddressId?: number;
    recipientEmail?: string | undefined;
}

export class ReceiptStatusModel implements IReceiptStatusModel {
    id?: number;
    statusText?: string | undefined;

    constructor(data?: IReceiptStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusText = _data["statusText"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReceiptStatusModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReceiptStatusModel>(data, _mappings, ReceiptStatusModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IReceiptStatusModel {
    id?: number;
    statusText?: string | undefined;
}

export class RoleModel implements IRoleModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    selected?: boolean;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any, _mappings?: any): RoleModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RoleModel>(data, _mappings, RoleModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["selected"] = this.selected;
        return data;
    }
}

export interface IRoleModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    selected?: boolean;
}

export class SampleInventoryLocationModel implements ISampleInventoryLocationModel {
    id?: number;
    locationName?: string | undefined;

    constructor(data?: ISampleInventoryLocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any, _mappings?: any): SampleInventoryLocationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SampleInventoryLocationModel>(data, _mappings, SampleInventoryLocationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface ISampleInventoryLocationModel {
    id?: number;
    locationName?: string | undefined;
}

export class SearchCriteriaModel implements ISearchCriteriaModel {
    id?: number;
    searchFormulaId?: number;
    criteriaName?: string | undefined;
    criteriaValue?: string | undefined;

    constructor(data?: ISearchCriteriaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.searchFormulaId = _data["searchFormulaId"];
            this.criteriaName = _data["criteriaName"];
            this.criteriaValue = _data["criteriaValue"];
        }
    }

    static fromJS(data: any, _mappings?: any): SearchCriteriaModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchCriteriaModel>(data, _mappings, SearchCriteriaModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["searchFormulaId"] = this.searchFormulaId;
        data["criteriaName"] = this.criteriaName;
        data["criteriaValue"] = this.criteriaValue;
        return data;
    }
}

export interface ISearchCriteriaModel {
    id?: number;
    searchFormulaId?: number;
    criteriaName?: string | undefined;
    criteriaValue?: string | undefined;
}

export class SearchFormulaModel implements ISearchFormulaModel {
    id?: number;
    name?: string | undefined;
    ownerId?: number | undefined;
    isShared?: boolean;
    dashboard?: string | undefined;
    enabled?: boolean | undefined;
    isCannedFilter?: boolean | undefined;
    searchCriteria?: SearchCriteriaModel[] | undefined;

    constructor(data?: ISearchFormulaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.isShared = _data["isShared"];
            this.dashboard = _data["dashboard"];
            this.enabled = _data["enabled"];
            this.isCannedFilter = _data["isCannedFilter"];
            if (Array.isArray(_data["searchCriteria"])) {
                this.searchCriteria = [] as any;
                for (let item of _data["searchCriteria"])
                    this.searchCriteria.push(SearchCriteriaModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SearchFormulaModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SearchFormulaModel>(data, _mappings, SearchFormulaModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["isShared"] = this.isShared;
        data["dashboard"] = this.dashboard;
        data["enabled"] = this.enabled;
        data["isCannedFilter"] = this.isCannedFilter;
        if (Array.isArray(this.searchCriteria)) {
            data["searchCriteria"] = [];
            for (let item of this.searchCriteria)
                data["searchCriteria"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchFormulaModel {
    id?: number;
    name?: string | undefined;
    ownerId?: number | undefined;
    isShared?: boolean;
    dashboard?: string | undefined;
    enabled?: boolean | undefined;
    isCannedFilter?: boolean | undefined;
    searchCriteria?: SearchCriteriaModel[] | undefined;
}

export class ShipmentDefectModel implements IShipmentDefectModel {
    id?: number;
    defectName?: string | undefined;

    constructor(data?: IShipmentDefectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.defectName = _data["defectName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShipmentDefectModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShipmentDefectModel>(data, _mappings, ShipmentDefectModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["defectName"] = this.defectName;
        return data;
    }
}

export interface IShipmentDefectModel {
    id?: number;
    defectName?: string | undefined;
}

export class UnitOfMeasureModel implements IUnitOfMeasureModel {
    id?: number;
    uomDisplay?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
    sortOrder?: number;

    constructor(data?: IUnitOfMeasureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uomDisplay = _data["uomDisplay"];
            this.description = _data["description"];
            this.isEnabled = _data["isEnabled"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnitOfMeasureModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnitOfMeasureModel>(data, _mappings, UnitOfMeasureModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uomDisplay"] = this.uomDisplay;
        data["description"] = this.description;
        data["isEnabled"] = this.isEnabled;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUnitOfMeasureModel {
    id?: number;
    uomDisplay?: string | undefined;
    description?: string | undefined;
    isEnabled?: boolean | undefined;
    sortOrder?: number;
}

export class UserModel implements IUserModel {
    id?: number;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    secondaryEmail?: string | undefined;
    middleInitial?: string | undefined;
    optInEmailNotification?: boolean;
    designation?: string | undefined;
    defaultLeadUserId?: number | undefined;
    isActive?: boolean;
    awaitingApproval?: boolean;
    functionId?: number;
    functionName?: string | undefined;
    isGlpeligible?: boolean;
    isApprover?: boolean;
    isProdManager?: boolean;
    roles?: RoleModel[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.secondaryEmail = _data["secondaryEmail"];
            this.middleInitial = _data["middleInitial"];
            this.optInEmailNotification = _data["optInEmailNotification"];
            this.designation = _data["designation"];
            this.defaultLeadUserId = _data["defaultLeadUserId"];
            this.isActive = _data["isActive"];
            this.awaitingApproval = _data["awaitingApproval"];
            this.functionId = _data["functionId"];
            this.functionName = _data["functionName"];
            this.isGlpeligible = _data["isGlpeligible"];
            this.isApprover = _data["isApprover"];
            this.isProdManager = _data["isProdManager"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(RoleModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): UserModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserModel>(data, _mappings, UserModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["secondaryEmail"] = this.secondaryEmail;
        data["middleInitial"] = this.middleInitial;
        data["optInEmailNotification"] = this.optInEmailNotification;
        data["designation"] = this.designation;
        data["defaultLeadUserId"] = this.defaultLeadUserId;
        data["isActive"] = this.isActive;
        data["awaitingApproval"] = this.awaitingApproval;
        data["functionId"] = this.functionId;
        data["functionName"] = this.functionName;
        data["isGlpeligible"] = this.isGlpeligible;
        data["isApprover"] = this.isApprover;
        data["isProdManager"] = this.isProdManager;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserModel {
    id?: number;
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    secondaryEmail?: string | undefined;
    middleInitial?: string | undefined;
    optInEmailNotification?: boolean;
    designation?: string | undefined;
    defaultLeadUserId?: number | undefined;
    isActive?: boolean;
    awaitingApproval?: boolean;
    functionId?: number;
    functionName?: string | undefined;
    isGlpeligible?: boolean;
    isApprover?: boolean;
    isProdManager?: boolean;
    roles?: RoleModel[] | undefined;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}